/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, {useEffect, useRef, useState} from 'react'
import {useParams} from 'react-router-dom'
import {getBlobUrl, getCard, getMarker, getMultiMarker, getMultiCard} from '../../redux/action/card'
import {useDispatch, useSelector} from 'react-redux'
import './video_overlay.css'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'
import {FontLoader} from 'three/examples/jsm/loaders/FontLoader'
import {SVGLoader} from 'three/examples/jsm/loaders/SVGLoader'
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader'
import {TextGeometry} from 'three/examples/jsm/geometries/TextGeometry'
import short from 'short-uuid'
import StatusOverlay from './status'
import {VERTEX_SHADER, FRAGMENT_SHADER} from './shaders'
import {MindARThree} from './three'
import {getFunctions, httpsCallable} from 'firebase/functions'
import {ReadJsonAtUrl} from '../../_4threal/helpers/ReadJsonAtUrl'
import {generatePopup} from '../../utils/popup'
import {Action} from '../../redux/actionTypes'
import { trackQRScan, trackARScan, trackLinkClick } from '../../utils/ga4Analytics'
import { getUserInfoByUID } from '../../utils/analyticsHelpers'
import {Step} from '../modules/cardform/components/editors/WalkthroughSteps'
import {
  MeshStandardMaterial, Color, ShaderMaterial,
  AmbientLight, DirectionalLight, DoubleSide, Clock, AnimationMixer, Vector2, Vector3, Box3,
  Raycaster, TextureLoader, VideoTexture, PlaneGeometry, ObjectLoader,
  MeshBasicMaterial, Mesh, LinearFilter, RGBAFormat, LineBasicMaterial, BufferGeometry, Line, SRGBColorSpace, sRGBEncoding, Shape, ExtrudeGeometry, MeshPhongMaterial, CanvasTexture, Group,
  BoxGeometry, Vector4, Matrix4, AdditiveBlending, ClampToEdgeWrapping, MeshLambertMaterial, PlaneBufferGeometry, Points, PointsMaterial, BufferAttribute
  // Scene, PerspectiveCamera, BoxGeometry, MeshPhongMaterial, WebGLRenderer, Math, Box3, Vector3, BoxGeometry,
} from 'three'
import Hls from 'hls.js'

import { CSS3DObject, CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer';
// import { fontConvert } from './fontConvert';
// interface DeviceOrientationEvent {
//   requestPermission: () => Promise<string>;
// }

function ARScene(props: any = { isPreview: false, currCard: {}, captureScreenshot: null, customScene: {}, isEditingCamera: false, isMuted: false, setIsMuted: null }) {
  const { isPreview, currCard, captureScreenshot, customScene, isEditingCamera, isMuted: propIsMuted, setIsMuted: propSetIsMuted } = props;
  
  const [localIsMuted, setLocalIsMuted] = useState(false);
  
  const isMuted = propIsMuted !== undefined ? propIsMuted : localIsMuted;
  const setIsMuted = propSetIsMuted || setLocalIsMuted;
  const begMindUrl = 'https://firebasestorage.googleapis.com/v0/b/xtyndedreality.appspot.com/o/placeholders%2Fplaceholder.mind?alt=media&token=b331d467-7b0d-4ddd-9f39-4a68c8ecabdc'
  const begVideoUrl = '/media/splash/placeholder_no_audio.mp4'
  const begLogoUrl = '/media/ar/yourlogo.png'
  // const [hasOrientationPermission, setHasOrientationPermission] = useState(false);
  const hasOrientationPermission = false
  const [isArInstanceStarted, setIsArInstanceStarted] = useState(false)
  const sceneRef = useRef<any>(null)
  const dispatch = useDispatch()
  const {id} = useParams()
  const functions = getFunctions()
  const reportAnalytics = httpsCallable(functions, 'reportAnalytics')
  const audioRefs: any = useRef([]);
  const currAssets: any = useRef({});
  const currLinks: any = useRef({});
  const currMarker: any = useRef({});
  const multiAssets: any = useRef({});
  const loadCount: any = useRef(0);
  const currCount: any = useRef(1);
  const sceneMap: any = useRef([]);
  const isDemo: any = useRef(false);
  const scard = useSelector((state: any) => state.Card?.card);
  const smarker = useSelector((state: any) => state.Card?.marker);
  const multiMarker = useSelector((state: any) => state.Card?.MultiMarker);
  const multiCard = useSelector((state: any) => state.Card?.MultiCard);
  const multiMarkerObj = useSelector((state: any) => state.Card?.MultiMarkerObj);
  const multiCardObj = useSelector((state: any) => state.Card?.MultiCardObj);
  const [arInstance, setArInstance] = useState<MindARThree>();
  const [renderer, setRenderer] = useState<any>(null);
  const [cssRenderer, setCssRenderer] = useState<any>(null);
  const [scene, setScene] = useState<any>(null);
  const [camera, setCamera] = useState<any>(null);
  const [target, setTarget] = useState<ArrayBuffer>();
  const [targetFound, setTargetFound] = useState(false);
  const [markerImg, setMarkerImg]: any = useState(null);
  const [markerImages, setMarkerImages]: any[] = useState([])
  const [overlayVideoUrl, setOverlayVideoUrl] = useState('/media/splash/splash2.mp4')
  const [isLoading, setIsLoading]: any = useState(true)
  const [isGettingCamera, setIsGettingCamera]: any = useState(false)
  const [isStartingAr, setIsStartingAr]: any = useState(false)
  const [contentLoaded, setContentLoaded]: any = useState(false)
  const [progress, setProgress]: any = useState(0)
  const isProcessing = false // omitting setIsProcessing due to eslint warning
  const [isReady, setIsReady]: any = useState(false)
  const [needsTap, setNeedsTap]: any = useState(true)
  const needsTapRef = useRef(true)
  const contentVisibleRef = useRef(false)
  // const isScanningRef = useRef(false);
  const [isScanning, setIsScanning]: any = useState(false);
  const [isError, setIsError]: any = useState('');
  const [isPublished, setIsPublished]: any = useState(false);
  const mouse: any = useRef(new Vector2());
  const canAcceptRaycast = useRef(false);
  const currentAnchor: any = useRef("");
  const anchors: any = useRef({});
  const debugLine: any = useRef(null);
  const debugClicks: any = useRef(false);
  const [lastLinks, setLastLinks]: any = useState('[]');
  const mindUrl: any = useRef('');
  const sceneCount: any = useRef(1);
  const [socialLinks, setSocialLinks]: any = useState([]);
  const [multiSocailLinks, setMultiSocialLinks]: any = useState([]);
  const [cameraDistance, setCameraDistance]: any = useState(3);
  const lastCard: any = useRef('{"sceneAssets":[]}');
  const allowUnanchored = useRef(true); // omitting setAllowUnanchored due to eslint warning
  const autoForwardUrl = useRef('')
  const longestVideoStartTime = useRef(0)
  const textureUpdateCallbacks = useRef<Record<string, () => void>>({})
  // Window-Scope States
  useEffect(() => {
    window['videoLoopCount'] = 0
    window['needsTap'] = true
  }, [])

  // hack to destroy all audio/video on unmount
  useEffect(() => {
    const win: any = window as any
    if (!win.__media) win.__media = new Set()
    if (!win.__mediaPatchCount) win.__mediaPatchCount = 0
    let didPatch = false
    if (!win.__mediaPatched) {
      try {
        const orig: (this: HTMLMediaElement, ...args: any[]) => Promise<any> | undefined = HTMLMediaElement.prototype.play as any
        win.__origPlay = orig
        HTMLMediaElement.prototype.play = function (this: HTMLMediaElement, ...args: any[]) {
          try { win.__media.add(this) } catch {}
          return orig ? orig.apply(this, args) : Promise.resolve()
        } as any
        win.__mediaPatched = true
        didPatch = true
      } catch {}
    }
    win.__mediaPatchCount = (win.__mediaPatchCount || 0) + 1
    return () => {
      try {
        const set: any = win.__media
        if (set && set.forEach) {
          set.forEach((m: any) => {
            try { m.pause() } catch {}
            try { m.muted = true } catch {}
            try { m.removeAttribute('src'); m.src = ''; m.load() } catch {}
          })
          try { set.clear() } catch {}
        }
      } catch {}
      try {
        if (win.__mediaPatchCount) {
          win.__mediaPatchCount -= 1
          if (win.__mediaPatchCount <= 0 && win.__origPlay) {
            HTMLMediaElement.prototype.play = win.__origPlay
            win.__mediaPatched = false
            win.__origPlay = null
            win.__mediaPatchCount = 0
          }
        }
      } catch {}
    }
  }, [])

  // Use this for window navigation (stops playback when clicking anywhere outside the window)
  useEffect(() => {
    if (!isPreview) {
      const handleFocus = () => unpauseMedia(currentAnchor.current)
      const handleBlur = () => stopMedia(currentAnchor.current)

      window.addEventListener('focus', handleFocus)
      window.addEventListener('blur', handleBlur)

      return () => {
        window.removeEventListener('focus', handleFocus)
        window.removeEventListener('blur', handleBlur)
      }
    }
  }, [])

  useEffect(() => {
    addCustomStuffToScene()
  }, [customScene])

  const addCustomStuffToScene = async () => {
    if (arInstance && customScene._id !== undefined) {
      if (customScene._id === 'CLEAR') {
        const objectInARScene = scene.getObjectByName('CustomScene')
        scene.remove(objectInARScene)
      } else {
        const jsonUrl = await dispatch(
          getBlobUrl({
            filename: `${customScene._id}.${customScene.scene.name}`,
            dirs: ['assets'],
            setUser: true,
          })
        )

        if (jsonUrl === Action.GET_BLOB_URL_FAIL) {
          generatePopup('error', '3D scene failed to load (the project may not exist in database)')
        } else {
          const jsonFromFirebase = await ReadJsonAtUrl(jsonUrl)
          console.log(jsonFromFirebase)
          //Remove the active scene first (don't want to add too many lights)
          const objectInARScene = scene.getObjectByName('CustomScene')
          scene.remove(objectInARScene)

          //Parse the json then add to the scene
          const loader = new ObjectLoader()
          const object = loader.parse(jsonFromFirebase.scene)
          object.name = 'CustomScene' //name the object for future removal
          scene.add(object)

          generatePopup('success', 'Project is has been loaded')
        }
      }
    }
  }

    // Helper function to detect if video has audio
    const detectVideoHasAudio = (video: HTMLVideoElement): Promise<boolean> => {
      return new Promise((resolve) => {
        // Method 1: Check audioTracks (most reliable for modern browsers)

        if ('audioTracks' in video) {
          const thisvideo = video as any
          if (thisvideo.audioTracks && thisvideo.audioTracks?.length > 0) {
            resolve(true)
            return
          }
        }

        // Method 2: Firefox-specific property
        if ('mozHasAudio' in video) {
          resolve((video as any).mozHasAudio)
          return
        }

        if ('webkitAudioDecodedByteCount' in video) {
          if ((video as any).webkitAudioDecodedByteCount > 0) {
            resolve(true)
            return
          }
        }
  
        // Method 3: Web Audio API approach (more complex but works cross-browser)
        try {
          const videoWithCapture = video as any
          if (videoWithCapture.captureStream) {
            const stream = videoWithCapture.captureStream()
            const audioTracks = stream.getAudioTracks()
            if (audioTracks.length > 0) {
              // Clean up the stream
              stream.getTracks().forEach((track: any) => track.stop())
              resolve(true)
              return
            }
          }
        } catch (error) {
          
          console.log('captureStream not supported:', error)
        }

        resolve(false)
      })
    }

  const checkTransparency = (imageUrl: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.crossOrigin = 'Anonymous' // Use as needed for cross-origin images
      img.src = imageUrl

      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height

        const ctx: any = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        const data = imageData.data

        for (let i = 0; i < data.length; i += 4) {
          // data[i + 3] is the alpha component of the pixel
          if (data[i + 3] === 0) {
            // Transparent pixel, make it black
            data[i] = 0 // Red
            data[i + 1] = 0 // Green
            data[i + 2] = 0 // Blue
            data[i + 3] = 255 // Fully opaque
          } else {
            // Opaque pixel, make it white
            data[i] = 255 // Red
            data[i + 1] = 255 // Green
            data[i + 2] = 255 // Blue
            // Alpha stays the same
          }
        }

        // Put the modified data back on the canvas
        ctx.putImageData(imageData, 0, 0)

        // Convert canvas to image URL
        const resultImageSrc = canvas.toDataURL()
        resolve(resultImageSrc)
      }

      img.onerror = (error) => {
        console.error('Error loading image:', error)
        resolve(null)
      }
    })
  }

  useEffect(() => {
    // Check if multiAssets has any anchors
    if (Object.keys(multiAssets.current).length > 0) {
      // Iterate through all anchors
      Object.values(multiAssets.current).forEach((anchorData: any) => {
        if (anchorData?.currAssets) {
          // Iterate through all assets in this anchor
          Object.values(anchorData.currAssets).forEach((asset: any) => {
            if (asset.type === 'video') {
              asset.ref.muted = isMuted
            } else if (asset.type === 'audio') {
              asset.ref.muted = isMuted
            }
          })
        }
      })
    }
  }, [isMuted])

  useEffect(() => {
    // console.log('id', id)
    if (!isPreview) {
      const idsp: any = id?.split('-')
      if (idsp.length > 1) {
        if (idsp[1] === 's') {
          console.log('getting card', idsp[0])
          dispatch(getCard({id: idsp[0]}))
          isDemo.current = true
        }
        // setCardId(idsp[0]);
      } else {
        console.log('getting marker', idsp[0])
        dispatch(getMarker({id: idsp[0]}))
      }
    }
  }, [id])

  // const saveAnalytics = (index: any) => {
  //   const newLinkKey = `link${index}`;
  //   dispatch(updateAnalytics({
  //     links: {
  //       [newLinkKey]: 1,
  //     }
  //   }, cardId))
  // };

  useEffect(() => {
    if (!scard) return
    if (Object.keys(scard).length) {
      if (!isPreview) {
        console.log('scard', scard)
        if (scard?.protected?.isActive || isDemo.current) {
          setProgress(0)
          if (isDemo.current){
            currMarker.current = {
              _id: scard?._id,
              mindUrl: scard?.mindUrl,
              isMulti: false,
              markerIds: [scard?._id],
              sceneId: scard?._id,
              protected: {
                isActive: true,
              }
            }
          }
          sceneMap.current[0] = {sceneId: scard?._id, marker: currMarker.current}
          //console.log('currMarker.current', currMarker.current)
          loadContent(scard, currMarker.current, currMarker.current?.mindUrl, scard?._id)
          setIsPublished(true)
        } else {
          const autoForward  = scard?.autoForwardUrl
          if (autoForward) {
            window.location.href = autoForward
          } else {
            window.location.href = 'https://www.skanteq.com/'
          }
          setIsPublished(false)
        }
      } else {
        console.log('previewscard', scard)
        sceneMap.current[0] = {sceneId: scard?._id, marker: currMarker.current}
        setProgress(0)
        //set last card if loading so asset deletes will register
        lastCard.current = JSON.stringify(scard)
        loadContent(scard, currMarker.current, begMindUrl, scard?._id)
      }
    } else {
      console.log('currCard', currCard)
      if (currCard) {
        console.log('currCard', currCard)
        sceneMap.current[0] = {sceneId: currCard?._id, marker: currMarker.current}
        setProgress(0)
        loadContent(currCard, currMarker.current, begMindUrl, currCard?._id)
      }
    }
  }, [scard])

  useEffect(() => {
    if (!isPreview) {
      if (smarker) {
        console.log('smarker', smarker)
        if (Object.keys(smarker).length) {
          if (smarker?.isMulti) {
            mindUrl.current = smarker?.mindUrl

            dispatch(getMultiMarker({ids: smarker?.markerIds}))
            setIsPublished(true)
          } else {
            currMarker.current = smarker
            dispatch(getCard({id: smarker?.sceneId}))

            if (smarker?.protected?.isActive) {
              //loadContent(smarker)
              //setIsPublished(true);
            } else {
              //setIsPublished(false);
              ////navigate("/")
            }
          }
        }
      } else {
        // generatePopup('error', 'Cannot load, a marker MUST be attributed to this AR scene')
        setIsError('marker-not-attributed')
      }
    }
  }, [smarker])

  useEffect(() => {
    if (multiMarker.length) {
      console.log('multiMarker', multiMarker)
      let scenes: any[] = []
      let sceneIds: string[] = []
      multiMarker.forEach((marker: any) => {
        scenes.push({sceneId: marker?.sceneId, marker: marker})
        sceneIds.push(marker?.sceneId)
      })
      sceneMap.current = scenes
      currentAnchor.current = scenes[0].sceneId
      dispatch(getMultiCard({ids: sceneIds}))
    }
  }, [multiMarker])

  useEffect(() => {
    if (Object.keys(multiCardObj).length) {
      console.log('multiCard', multiCardObj)
      loadContentMulti(multiCardObj)
    }
  }, [multiCardObj])

  const parseUrl = (url: string) => {
    let parsed = url

    if (url && process.env.REACT_APP_LOCAL_IP && url.includes('http://localhost:9199')) {
      parsed = url.replace(
        'http://localhost:9199',
        'http://' + process.env.REACT_APP_LOCAL_IP + ':9199'
      )
    }
    return parsed
  }

  const addAsset = async (asset: any, assetId: string, anchorId, load = false) => {
    console.log('adding asset', asset)
    return new Promise(async (resolve, reject) => {
      let thisneedsTap = false

      //asset['url'] = parseUrl(asset.url)
      console.log('adding asset', asset.url)
      if (asset.type === 'video') {
        if (asset.chromaKeyColor === '') {
          setOverlayVideoUrl(asset.url)
        }else{
          //remove chromakey volume
          asset['volume'] = 0;
          asset['muted'] = true;
        }

        const useStreaming = !isPreview && asset.streamUrl && Hls.isSupported()
        let video: any
        if (useStreaming) {
          console.log('Using streaming video for:', asset.streamUrl)
          try {
            video = await loadStreamingVideo(asset)
          } catch (error: any) {
            console.warn('Streaming video failed, falling back to regular video:', error.message)
            // Fallback to regular video if streaming fails
            video = await loadVideo(asset)
          }
        } else {
          console.log('Using regular video for:', asset.url)
          video = await loadVideo(asset)
        }
        let entry = {
          ref: video.ref,
          type: 'video',
          canplay: video.canplay,
          asset: asset,
          hls: video.hls,
          isStreaming: useStreaming && video.hls, // Only true if streaming actually worked
        }
        if (!video.canplay) {
          thisneedsTap = true
        }
        if (load) {
          if (!needsTap || isPreview) {
            let mesh: any
            if (entry.isStreaming) {
              console.log('Using streaming video for:', asset.streamUrl)
              mesh = makeStreamingVideo(entry, assetId, anchorId)
            } else {
              console.log('Using regular video for:', asset.url)
              mesh = await makeVideo(entry, assetId, anchorId)
            }
            
            entry['mesh'] = mesh;
            if (video.ref.readyState >= video.ref.HAVE_METADATA) { // Check if duration is available
              const seekTime = Math.min(4, video.ref.duration); // Seek to 4s or end, whichever is shorter
              video.ref.currentTime = seekTime;
              console.log(`Set currentTime to: ${seekTime} (Video duration: ${video.ref.duration})`);
              const hasAudio = await detectVideoHasAudio(video.ref)
              console.log('Video has audio:', hasAudio)
              if (!hasAudio) {
                setIsMuted(true)
              }else{
                setIsMuted(false)
              }
              captureScreenshot(video.ref, currCard, assetId, hasAudio);
              video.ref.currentTime = 0;
              video.ref.play();
            }
            
           
          }
        }
        multiAssets.current[anchorId].currAssets[assetId] = entry;
      } else if (asset.type === 'youtube_video') {
        console.log('adding YouTube video', asset.url, asset.youtubeId)
        let entry = {
          ref: null, // YouTube videos don't need a video element reference
          type: 'youtube_video',
          canplay: true, // YouTube embeds are always ready
          asset: asset,
        }
        
        if (load) {
          const youtubeObjects = makeYoutube(entry, assetId, anchorId);
          if (youtubeObjects) {
            entry['mesh'] = youtubeObjects.cssObject;
            entry['shadowPlane'] = youtubeObjects.shadowPlane;
          }
        }
        multiAssets.current[anchorId].currAssets[assetId] = entry
      } else if (asset.type === 'audio') {
        const audioasset: any = await loadAudio(asset);
        console.log('audio', audioasset)
        let entry = {
          ref: audioasset.ref,
          type: 'audio',
          canplay: audioasset.canplay,
          asset: audioasset,
        }
        if (!audioasset.canplay) {
          thisneedsTap = true;
        }

        if (load) {
          console.log('loading audio', needsTap, isPreview)
          if (!needsTap || isPreview) {
          if (audioasset.ref.readyState >= audioasset.ref.HAVE_METADATA) {
              console.log('playing audio', audioasset.ref)
              setIsMuted(false)
              audioasset.ref.muted = false
              audioasset.ref.volume = 1
              audioasset.ref.play();
            }
          }
        }
        multiAssets.current[anchorId].currAssets[assetId] = entry
      } else if (asset.type === 'model') {
        //console.log('loading model', asset.url, anchorId, assetId)
        const model: any = await loadModel(asset.url)
        //console.log('loading  model finsihed', model, anchorId, assetId)
        let entry = {
          ref: model.scene,
          animations: model.animations,
          type: 'model',
          asset: asset,
        }
        //console.log('loading load', load, asset.url, anchorId, assetId)
        if (load) {
          //console.log('loading make3Dmodel', load, asset.url, anchorId, assetId)
          const mesh = make3Dmodel(entry, assetId, anchorId)
          //console.log('loading make3Dmodel finished', mesh)
          entry['mesh'] = mesh
          // Add particle effects if configured
          if (mesh && asset?.particleEffects) {
            addParticleEffects(mesh, anchorId, asset.particleEffects)
          }
        }
        multiAssets.current[anchorId].currAssets[assetId] = entry
      } else if (asset.type === 'image') {
        const image: any = await loadTexture(asset.url)
        const normalmap: any = await checkTransparency(asset.url)
        let entry = {
          ref: image,
          type: 'image',
          normalmap: normalmap,
          asset: asset,
        }

        if (load) {
          const mesh = makeLogo(entry, assetId, anchorId)
          entry['mesh'] = mesh
          // Add particle effects if configured
          if (mesh && asset?.particleEffects) {
            addParticleEffects(mesh, anchorId, asset.particleEffects)
          }
        }
        multiAssets.current[anchorId].currAssets[assetId] = entry
      } else if (asset.type === 'text') {
        const font: any = await loadFont(asset.url)
        let entry = {
          ref: font,
          type: 'text',
          asset: asset,
        }

        if (load) {
          const mesh = makeText(entry, assetId, anchorId)
          entry['mesh'] = mesh
          // Add particle effects if configured
          if (mesh && asset?.particleEffects) {
            addParticleEffects(mesh, anchorId, asset.particleEffects)
          }
        }
        multiAssets.current[anchorId].currAssets[assetId] = entry
      } else if (asset.type === 'button') {
        let entry = {
          ref: null,
          type: 'button',
          asset: asset,
        }

        if (load) {
          const mesh = await makeButton(entry, assetId, anchorId)
          if (mesh) {
            entry['mesh'] = mesh
            // Add particle effects if configured
            if (asset?.particleEffects) {
              addParticleEffects(mesh, anchorId, asset.particleEffects)
            }
          }
        }
        multiAssets.current[anchorId].currAssets[assetId] = entry
      }
      /*
      if (asset?.linkUrl){
        setLinkObjects([...linkObjects, multiAssets.current[currentAnchor].currAssets[assetId].ref]);
        setLinkIds([...linkIds, assetId]);
        setLinks([...links, asset.linkUrl]);
      }
      */
      if (loadCount.current > 0) {
        setProgress((currCount.current / loadCount.current) * 100)
      }
      currCount.current++
      resolve(thisneedsTap)
    })
  }

  const removeAsset = (assetId: string) => {
    console.log('removing asset', assetId)
    if (multiAssets.current[currentAnchor.current]?.currAssets?.[assetId]) {
      if (multiAssets.current[currentAnchor.current].currAssets[assetId].type === 'video') {
        multiAssets.current[currentAnchor.current].currAssets[assetId].ref.pause()
      } else if (multiAssets.current[currentAnchor.current].currAssets[assetId].type === 'audio') {
        multiAssets.current[currentAnchor.current].currAssets[assetId].ref.pause();
      } else if (multiAssets.current[currentAnchor.current].currAssets[assetId].type === 'youtube_video') {
        // For YouTube videos, remove both CSS3D object and shadow plane
        const currAsset = anchors.current[currentAnchor.current]?.group?.getObjectByName(assetId);
        if (currAsset) {
          anchors.current[currentAnchor.current].group.remove(currAsset);
        }
        
        const shadowPlane = anchors.current[currentAnchor.current]?.group?.getObjectByName(assetId + '_shadow');
        if (shadowPlane) {
          anchors.current[currentAnchor.current].group.remove(shadowPlane);
        }
        
        delete multiAssets.current[currentAnchor.current].currAssets[assetId];
        return; // Exit early to avoid duplicate cleanup
      }
      
      const currAsset = anchors.current[currentAnchor.current]?.group?.getObjectByName(assetId);
      console.log('currAsset', currAsset)
      if (currAsset) {
        // Remove all particle effects before removing the asset (handles both old and new formats)
        removeAllParticleEffects(currAsset, currentAnchor.current)
        anchors.current[currentAnchor.current].group.remove(currAsset)
      }
      delete multiAssets.current[currentAnchor.current].currAssets[assetId]
    }
  }

  const onMouseMove = (event) => {
    const bounds = renderer.domElement.getBoundingClientRect()

    canAcceptRaycast.current =
      bounds.left < event.clientX &&
      event.clientX < bounds.right &&
      bounds.top < event.clientY &&
      event.clientY < bounds.bottom

    if (canAcceptRaycast.current) {
      //small optimization
      // Adjust for scrolling by removing window.scrollX and window.scrollY
      mouse.current.x = ((event.clientX - bounds.left) / bounds.width) * 2 - 1
      mouse.current.y = -((event.clientY - bounds.top) / bounds.height) * 2 + 1
    }
  }

  const onLinkClick = (event) => {
    console.log('clicked')
    //event.preventDefault();
    //event.stopPropagation();
    if ((!needsTapRef.current && contentVisibleRef.current) || isPreview) {
      if (mouse.current && camera && canAcceptRaycast.current) {
        console.log('click passed')
        const traycaster = new Raycaster()
        traycaster.setFromCamera(mouse.current, camera)
        console.log(traycaster.ray.origin, traycaster.ray.direction)

        let linkObjs: any = []
        let linkIds: any = {}

        anchors.current[currentAnchor.current]?.group?.traverse((child) => {
          //console.log('child', child)
          if (child.isMesh && child?.userData?.linkUrl) {
            linkObjs.push(child)
            linkIds[child.uuid] = child.userData.linkUrl
          }
        })

        linkObjs.forEach((obj) => {
          //console.log('linkobj', obj);
        })

        console.log('Mouse:', mouse.current.x, mouse.current.y)
        console.log('Mouse:', mouse.current.x, mouse.current.y)

        if (debugClicks.current) {
          if (debugLine.current) {
            scene.remove(debugLine.current)
            debugLine.current.geometry.dispose()
            debugLine.current.material.dispose()
            debugLine.current = null
          }

          // Create a new debug line representing the ray
          const lineMaterial = new LineBasicMaterial({color: 0xff0000})
          const lineGeometry = new BufferGeometry().setFromPoints([
            traycaster.ray.origin,
            traycaster.ray.origin.clone().add(traycaster.ray.direction.clone().multiplyScalar(100)), // Adjust scalar as needed
          ])
          debugLine.current = new Line(lineGeometry, lineMaterial)
          scene.add(debugLine.current)
        }

        const intersects = traycaster.intersectObjects(linkObjs, true)
        console.log('intersects', intersects)
        for (var i = 0; i < intersects.length; i++) {
          console.log('intersect', intersects[i].object)
          if (intersects[i].object.uuid in linkIds) {
            const linkUrl = linkIds[intersects[i].object.uuid]
            const url =
              linkUrl.startsWith('http://') ||
              linkUrl.startsWith('https://') ||
              linkUrl.startsWith('tel:') ||
              linkUrl.startsWith('sms:')
                ? linkUrl
              : `https://${linkUrl}`

            console.log('link',url)
            if (!isPreview && !isDemo.current) {
              /*
              triggerAnalytics('click', linkIds[intersects[i].object.uuid]).then(() => {
                window.open(linkIds[intersects[i].object.uuid])
              }).catch((err) => {
                console.log('analytics error', err)
              })
                */
              triggerAnalytics('click', url)
            }
           
            
            if (!isPreview) {
              window.open(url, '_self')
            }else{
              window.open(url, '_blank')
            }
            break
          }
        }
      }
    }
  }

  useEffect(() => {
    if (renderer && renderer?.domElement) {
      document.addEventListener('mousemove', onMouseMove)
    }
    return () => {
      document.removeEventListener('mousemove', onMouseMove)
    }
  }, [renderer])

  useEffect(() => {
    const handleClick = (event) => {
      // setIsMuted(false)
      onLinkClick(event)
    }
    if (camera) {
      document.addEventListener('click', handleClick)
    }
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [camera])

  useEffect(() => {
    if (!currCard) return

    const currCardString = JSON.stringify(currCard)
    const assetsString = JSON.stringify(currCard?.sceneAssets)
    console.log('currCardString', currCardString)
    console.log('lastCard', lastCard.current)
    
    let currLastCard: any = null
    try {
      if (lastCard.current && lastCard.current !== '{}' && lastCard.current !== '') {
        currLastCard = JSON.parse(lastCard.current)
      }
    } catch (e) {
      console.log('Error parsing lastCard.current:', e)
      currLastCard = null
    }
    
    const lastCardAssets = currLastCard ? JSON.stringify(currLastCard.sceneAssets) : '{}'
    if (currCardString === lastCard.current) {
      console.log('same card')
      return
    }

    // Check if card ID has changed (B2B account switching)
    // Also check if we have anchor data with a different ID than current card
    const availableAnchorIds = Object.keys(anchors.current)
    const needsMigration = availableAnchorIds.length > 0 && 
                          !availableAnchorIds.includes(currCard._id) && 
                          availableAnchorIds[0] !== currCard._id

    if (needsMigration) {
      const oldAnchorId = availableAnchorIds[0] // Use the first available anchor ID as the old one
      console.log('Card ID changed - migrating anchor data:', {
        oldId: oldAnchorId,
        newId: currCard._id,
        availableAnchors: Object.keys(anchors.current),
        availableMultiAssets: Object.keys(multiAssets.current)
      })
      
      // Migrate anchor data from old ID to new ID
      if (anchors.current[oldAnchorId] && !anchors.current[currCard._id]) {
        anchors.current[currCard._id] = anchors.current[oldAnchorId]
        delete anchors.current[oldAnchorId]
        console.log('Migrated anchor data from', oldAnchorId, 'to', currCard._id)
      }
      
      // Migrate multiAssets data from old ID to new ID
      if (multiAssets.current[oldAnchorId] && !multiAssets.current[currCard._id]) {
        multiAssets.current[currCard._id] = multiAssets.current[oldAnchorId]
        delete multiAssets.current[oldAnchorId]
        console.log('Migrated multiAssets data from', oldAnchorId, 'to', currCard._id)
      }
      
      // Update sceneMap to use new card ID
      if (sceneMap.current[0] && sceneMap.current[0].sceneId === oldAnchorId) {
        sceneMap.current[0].sceneId = currCard._id
        console.log('Updated sceneMap from', oldAnchorId, 'to', currCard._id)
      }
      
      // Update currentAnchor to use new card ID
      if (currentAnchor.current === oldAnchorId) {
        currentAnchor.current = currCard._id
        console.log('Updated currentAnchor from', oldAnchorId, 'to', currCard._id)
      }
    }

    if (!arInstance) {
      console.log('no ar instance')
      return
    }
    //console.log(currCard)

    lastCard.current = currCardString
    console.log('lastCard2', lastCard.current)

    setSocialLinks(currCard?.socials)
    setCameraDistance(currCard?.cameraDistance || 3)
    let assetPromises = []
    async function updateAssets() {
      //delete assets not in current card
      Object.keys(currLastCard?.sceneAssets || {}).forEach((assetId) => {
        if (!(assetId in currCard.sceneAssets)) {
          console.log('removing asset', assetId)
          removeAsset(assetId)
        }
      })

      Object.keys(currCard.sceneAssets).forEach((assetId) => {
        // if (!(assetId in currLastCard.sceneAssets)) {

        console.log('updateAssets', JSON.stringify(currCard?.sceneAssets[assetId]))
        const asset = currCard?.sceneAssets[assetId]
        if (asset.type === 'text' || asset.type === 'button') {
          addAsset(asset, assetId, currCard?._id, true)
        } else {
          console.log('updating asset', multiAssets.current[currentAnchor.current])
          if (assetId === 'userVideo' && currLastCard && 'userVideo' in (currLastCard.sceneAssets || {})) {
            if (currCard?.sceneAssets['userVideo'].url !== currLastCard?.sceneAssets?.['userVideo']?.url) {
              console.log('userVideo URL changed, recreating mesh with new aspect ratio');
              
              // Remove the old video mesh first
              const existingMesh = anchors.current[currentAnchor.current]?.group?.getObjectByName('userVideo');
              if (existingMesh) {
                anchors.current[currentAnchor.current].group.remove(existingMesh);
              }
              
              // Pause and clean up the old video
              const userVideo = multiAssets.current[currentAnchor.current]?.currAssets?.['userVideo']
              if (userVideo?.ref && !userVideo.ref.paused) {
                userVideo.ref.pause();
              }
              
              // Create new video element with new source
              const newVideoElement = document.createElement('video');
              newVideoElement.id = 'userVideo';
              newVideoElement.src = currCard.sceneAssets['userVideo'].url;
              newVideoElement.muted = userVideo.ref.muted;
              newVideoElement.loop = userVideo.ref.loop;
              newVideoElement.volume = userVideo.ref.volume;
              newVideoElement.autoplay = false;
              newVideoElement.playsInline = true;
              newVideoElement.crossOrigin = 'anonymous';
              newVideoElement.preload = 'auto';
              
              // Wait for new video metadata to load, then recreate mesh
              const recreateMesh = async () => {
                console.log('New video metadata loaded, creating mesh with dimensions:', 
                  newVideoElement.videoWidth, 'x', newVideoElement.videoHeight);
                
                // Update the video reference
                userVideo.ref = newVideoElement;
                userVideo.asset = currCard.sceneAssets['userVideo'];
                
                // Create new mesh with correct aspect ratio
                let newMesh;
                if (userVideo.isStreaming) {
                  newMesh = makeStreamingVideo(userVideo, 'userVideo', currentAnchor.current);
                } else {
                  newMesh = await makeVideo(userVideo, 'userVideo', currentAnchor.current);
                }
                
                userVideo.mesh = newMesh;
                
                // Set video time and play
              if (newVideoElement.readyState >= newVideoElement.HAVE_METADATA) {
                 const seekTime = Math.min(4, newVideoElement.duration);
                  newVideoElement.currentTime = seekTime;
                  console.log(`Set currentTime to: ${seekTime} (Video duration: ${newVideoElement.duration})`);
                  const hasAudio = await detectVideoHasAudio(newVideoElement)
                  console.log('Video has audio:', hasAudio)
                  captureScreenshot(newVideoElement, currCard, 'userVideo', hasAudio);
                  newVideoElement.currentTime = 0;
                  newVideoElement.play();
                }
              };
              
              // Listen for metadata load
              if (newVideoElement.readyState >= newVideoElement.HAVE_METADATA) {
                console.log('metadata loaded')
                // Already loaded
                recreateMesh();
              } else {
                newVideoElement.addEventListener('loadedmetadata', recreateMesh, { once: true });
                newVideoElement.addEventListener('canplay', () => {
                  if (newVideoElement.videoWidth > 0 && newVideoElement.videoHeight > 0) {
                    recreateMesh();
                  }
                }, { once: true });
              }
              
              // Start loading the new video
              newVideoElement.load();
            }else{
              console.log('userVideo asset', asset)
              if (asset.hasAudio && !isMuted) {
                if (asset?.volume > 0) {
                  const userVideo = multiAssets.current[currentAnchor.current]?.currAssets?.['userVideo']
                  if (userVideo?.ref) {
                    userVideo.ref.muted = asset?.muted || false;
                    userVideo.ref.volume = asset.volume;

                  }
                }
              }
             
            }


          }
            //addAsset(asset, assetId, currCard?._id, true);

            const lastAsset = currLastCard?.sceneAssets?.[assetId]

            if (!(assetId in (currLastCard?.sceneAssets || {}))) {
              console.log('adding Asset', assetId)
              addAsset(asset, assetId, currCard?._id, true)
            } else {
              console.log('updating asset', assetId)

              const lastAssetString = JSON.stringify(asset)
              const currAssetString = JSON.stringify(lastAsset)

              if (lastAssetString !== currAssetString) {
                console.log('assets dont match', assetId)
                console.log(multiAssets.current[currentAnchor.current]?.currAssets)
                
                // Check if this is a video asset with URL change - need to recreate mesh
                if (asset.type === 'video' && asset.url !== lastAsset.url) {
                  console.log(`Video ${assetId} URL changed, recreating mesh with new aspect ratio`);
                  
                  // Remove existing asset and recreate with new URL
                  removeAsset(assetId);
                  addAsset(asset, assetId, currentAnchor.current, true);
                  return; // Skip the rest of the update logic since we recreated the asset
                }

                
                if (multiAssets.current[currentAnchor.current]?.currAssets?.[assetId]) {
                  multiAssets.current[currentAnchor.current].currAssets[assetId]['asset'] = asset;
                  const assetRef = multiAssets.current[currentAnchor.current].currAssets[assetId].ref;

                  const sceneref =
                    anchors.current[currentAnchor.current]?.group?.getObjectByName(assetId)

                  console.log('sceneref', sceneref)

                if (sceneref && asset?.chromaKeyColor !== lastAsset?.chromaKeyColor) {
                  console.log('chromacolor mismatch', assetId)
                  if (!asset?.chromaKeyColor || !lastAsset?.chromaKeyColor) {
                    console.log('material switched', assetId)
                    if (!asset?.chromaKeyColor) {
                      console.log('removing chromakey', assetId)
                      //remove chroma key
                      const videoTexture = sceneref.material.uniforms.tex.value
                      const newMaterial = new MeshBasicMaterial({map: videoTexture})
                      newMaterial.shadowSide = DoubleSide
                      sceneref.material.dispose()
                      sceneref.material = newMaterial
                      sceneref.material.needsUpdate = true
                    } else {
                      console.log('adding chromakey', asset?.chromaKeyColor)
                      //add chroma key
                      const videoTexture = sceneref.material.map
                      const color = new Color(asset?.chromaKeyColor)
                      const width = videoTexture.image.videoWidth
                      const height = videoTexture.image.videoHeight
                      const chromaKeyMaterial = new ShaderMaterial({
                        uniforms: {
                          tex: {value: videoTexture},
                          keyColor: {value: color},
                          texWidth: {value: width},
                          texHeight: {value: height},
                          similarity: {value: 0.01},
                          smoothness: {value: 0.18},
                          spill: {value: 0.1},
                        },
                        vertexShader: VERTEX_SHADER,
                        fragmentShader: FRAGMENT_SHADER,
                        transparent: true,
                      })
                      chromaKeyMaterial.shadowSide = DoubleSide
                      sceneref.material.dispose()
                      sceneref.material = chromaKeyMaterial
                      sceneref.material.needsUpdate = true
                    }
                  } else {
                    console.log('removing chromakey', assetId)
                    sceneref.material.uniforms.keyColor.value = new Color(asset.chromaKeyColor)
                    sceneref.material.needsUpdate = true
                  }
                }

                console.log('sceneref', sceneref)

                if (sceneref && 'coords' in asset) {
                  Object.keys(asset.coords).forEach((coord) => {
                    let lastCoords = JSON.stringify(lastAsset.coords[coord])
                    let coords = JSON.stringify(asset.coords[coord])

                    if (coords !== lastCoords) {
                      sceneref.matrix.identity()
                      console.log('sceneref', sceneref)
                      if (coord === 'p') {
                        console.log('changing postions', asset.coords[coord])
                        sceneref.position.set(
                          asset.coords.p[0],
                          asset.coords.p[1],
                          asset.coords.p[2]
                        )
                      } else if (coord === 'r') {
                        console.log('changing rotation', asset.coords[coord])
                        sceneref.rotation.set(
                          asset.coords.r[0],
                          asset.coords.r[1],
                          asset.coords.r[2]
                        )
                      } else if (coord === 's') {
                        console.log('changing scale', asset.coords[coord])
                        sceneref.scale.set(asset.coords.s, asset.coords.s, asset.coords.s)
                      }
                      console.log('Updating Matrix', asset.coords[coord])
                      sceneref.updateMatrixWorld(true)
                    }
                  })
                }

                if (asset?.volume !== lastAsset?.volume) {
                  console.log('changing volume', assetId)
                  console.log(assetRef)
                  assetRef.muted = false;
                  assetRef.volume = asset.volume;

                }

                if (sceneref && asset?.linkUrl !== lastAsset?.linkUrl) {
                  sceneref.traverse((child) => {
                    if (child.isMesh) {
                      if (asset?.linkUrl) {
                        child.userData['linkUrl'] = asset.linkUrl
                      } else {
                        if ('linkUrl' in child.userData) {
                          delete child.userData['linkUrl']
                        }
                      }
                    }
                  })
                }

                // Handle particle effect changes
                if (sceneref && (asset.type === 'model' || asset.type === 'image' || asset.type === 'text' || asset.type === 'button' || asset.type === 'video')) {
                  const currEffects = JSON.stringify(asset?.particleEffects || {})
                  const lastEffects = JSON.stringify(lastAsset?.particleEffects || {})
                  
                  if (currEffects !== lastEffects) {
                    console.log('Particle effects changed for', assetId)
                    
                    if (asset?.particleEffects) {
                      addParticleEffects(sceneref, currentAnchor.current, asset.particleEffects)
                    } else {
                      removeAllParticleEffects(sceneref, currentAnchor.current)
                    }
                  }
                }
                }
              }
            }
        }
      })
    }

    if (currLastCard && lastCardAssets !== assetsString) {
      updateAssets()
    }

    // const linkString = JSON.stringify(currCard.links); // omitting due to eslint warning
    const last = JSON.parse(lastLinks)
    console.log('last', last)
    console.log('currCard.links', currCard.links)
    let ids: any = []
    if (last.length) {
      last.forEach((link, index) => {
        ids.push(link.id)
      })
    }

    const toBeRemoved: any = []
    if (anchors.current[currentAnchor.current]?.group) {
      anchors.current[currentAnchor.current].group.traverse((ac: any) => {
        if (ids.includes(ac.userData['identifier'])) {
          toBeRemoved.push(ac)
        }
      })

      toBeRemoved.forEach((ac) => anchors.current[currentAnchor.current].group.remove(ac))

      const test1 = anchors.current[currentAnchor.current].group.getObjectByName('test1')
      const test2 = anchors.current[currentAnchor.current].group.getObjectByName('test2')

      if (currCard.links.length) {
        console.log('gotlinks')
        console.log(anchors.current[currentAnchor.current].group)
        if (test1) {
          anchors.current[currentAnchor.current].group.remove(test1)
        }
        if (test2) {
          anchors.current[currentAnchor.current].group.remove(test2)
        }
        makeLinks(currCard.links, currentAnchor.current, 0.05, -0.45, true)
      } else {
        console.log('dontgotlinks')
        if (
          currCard?.currStep === Step.UploadVideo_4 &&
          !isEditingCamera &&
          !currCard.protected?.isActive
        ) {
          const prelinks: any = []
          if (!test1) {
            prelinks.push({link: 'www.youtube.com', id: 'test1', type: 'web', text: 'Visit Us'})
          }
          if (!test2) {
            prelinks.push({link: 'www.facebook.com', id: 'test2', type: 'web', text: 'Visit Us'})
          }
          makeLinks(prelinks, currentAnchor.current)
        } else {
          const baseVideo = anchors.current[currentAnchor.current].group.getObjectByName('baseVideo')
          const baseImage = anchors.current[currentAnchor.current].group.getObjectByName('baseImage')
          if (baseVideo) {
            if (multiAssets.current[currentAnchor.current]?.currAssets?.['baseVideo']?.ref && isPlaying(multiAssets.current[currentAnchor.current].currAssets['baseVideo'].ref)) {
              multiAssets.current[currentAnchor.current].currAssets['baseVideo'].ref.pause()
            }
            anchors.current[currentAnchor.current].group.remove(baseVideo)
          }
          if (baseImage) {
            anchors.current[currentAnchor.current].group.remove(baseImage)
          }
        }
      }
    }

    //setLastCard(currCardString);
  }, [currCard])


const parsePreviewChanges = () => {
  console.log('parsePreviewChanges')
}



  // useEffect(() => {
  //   if (!isLoading) {
  //     if (currLogo.image) {
  //       let logo = { ...currLogo };
  //       if (id === 'uGFeS2yMTZuLvMrDmGycNE') {
  //         logo.scale = 4;
  //         logo.position = [0, -.25, .1];
  //         logo.rotation = [0, 0, 0];
  //         makeLogo(logo);
  //       } else {
  //         makeLogo(logo);
  //       }
  //     }
  //   }
  //   //makeLogo();
  // }, [currLogo])

  useEffect(() => {
    if (isPreview) {
      contentVisibleRef.current = true
      if (currCard && Object.keys(currCard).length > 0) {
        // setCard(currCard); // omitting, card is never used
      }
    }
    // Event listener for target found
    const handleTargetFound = (event: any) => {
      //console.log('targetFOund', event?.detail?.targetIndex)
      const index = event?.detail?.targetIndex
      //console.log('sceneMap.current',  sceneMap.current)
      const scene = sceneMap.current[index]
      //console.log('scene', scene)
      if (scene.sceneId !== currentAnchor.current) {
        currentAnchor.current = scene.sceneId
      }

      setTargetFound(true)

      contentVisibleRef.current = true
    }

    // Event listener for target lost
    const handleTargetLost = () => {
      setTargetFound(false)
      if (!allowUnanchored.current) {
        contentVisibleRef.current = false
      }
    }

    const handleError = (event) => {
      const errorMessage = event.detail || 'Error loading AR content'
      console.log('error event fired')
      console.log(errorMessage)
      setIsLoading(false)
      // setIsError(errorMessage);
    }

    // Add event listeners
    document.addEventListener('targetFound', handleTargetFound)
    document.addEventListener('targetLost', handleTargetLost)
    document.addEventListener('error', handleError)
    // Cleanup event listeners
    return () => {
      document.removeEventListener('targetFound', handleTargetFound)
      document.removeEventListener('targetLost', handleTargetLost)
      document.removeEventListener('error', handleError)
      stopAllMedia()
      destroyAllMedia()
      try {
        Object.keys(textureUpdateCallbacks.current).forEach((key) => {
          try { textureUpdateCallbacks.current[key]() } catch {}
          delete textureUpdateCallbacks.current[key]
        })
      } catch {}
      try {
        if (cssRenderer && cssRenderer.domElement && cssRenderer.domElement.parentNode) {
          cssRenderer.domElement.parentNode.removeChild(cssRenderer.domElement)
        }
      } catch (e) {}
      try {
        disposeThreeResources()
      } catch (e) {}
      try {
        if (arInstance) {
          try { arInstance.stop() } catch (e) {}
          try { arInstance.cancelAnimation() } catch (e) {}
          try { arInstance.renderer.setAnimationLoop(null) } catch (e) {}
          try {
            const gl: any = arInstance.renderer.getContext()
            const ext = gl && gl.getExtension && gl.getExtension('WEBGL_lose_context')
            if (ext && ext.loseContext) ext.loseContext()
          } catch (e) {}
          try { arInstance.renderer.dispose() } catch (e) {}
          try {
            if (arInstance.renderer && arInstance.renderer.domElement && arInstance.renderer.domElement.parentNode) {
              arInstance.renderer.domElement.parentNode.removeChild(arInstance.renderer.domElement)
            }
          } catch (e) {}
        }
      } catch (e) {}
    }
  }, [])

  useEffect(() => {
    if (arInstance) {
      if (contentVisibleRef.current || allowUnanchored.current) {
        arInstance.setVisible(true)
        startMediaInCurrentAnchor()
      } else {
        setIsScanning(true)
      }
    }
  }, [isArInstanceStarted])

  useEffect(() => {
    console.log('contentVisible', contentVisibleRef.current)

    if (isReady) {
      console.log('isReady', isReady)
      setIsLoading(false)
    }

    const startAr = async () => {
      if (arInstance) {
        console.log('arinstance', arInstance, anchors.current)

        if (!isArInstanceStarted) {
          setIsStartingAr(true)
          setIsGettingCamera(true)
          //only initialize these once
          try {
            await arInstance._startVideo()
            setIsGettingCamera(false)
          } catch (err) {
            setIsLoading(false)
            setIsGettingCamera(false)
            setIsStartingAr(false)
            console.log('error starting video', err)
            setIsError('error starting video')
            return
          }
          await arInstance._startAR()
          setIsArInstanceStarted(true)
          if (!isPreview && !isDemo.current) {
            triggerAnalytics('ar_play')
          }
          setIsStartingAr(false)
        }

        arInstance.startProcessing()

        const particleClock = new Clock()
        renderer.setAnimationLoop(() => {
          // Update particle effects
          const delta = particleClock.getDelta()
          updateParticleEffects(delta)
          
          renderer.render(scene, camera);
          // Render CSS3D objects with the same camera for proper synchronization
          if (cssRenderer && scene && camera) {
            cssRenderer.render(scene, camera);
          }
        });

        needsTapRef.current = needsTap
      }

      //document.addEventListener('mousemove', onMouseMove, false);
      // Listen for click event to check intersections
      //document.addEventListener('click', onLinkClick, false);
    }

    if (!needsTap && isReady) {
      startAr()
    } else {
      needsTapRef.current = needsTap
    }
  }, [isReady, needsTap])

  useEffect(() => {
    if (arInstance && contentLoaded) {
      const startvideo = async () => {
        //await arInstance._startVideo();
        setRenderer(arInstance.renderer);
        setScene(arInstance.scene);
        
        // Set up CSS3D renderer for YouTube videos with proper camera synchronization
        const css3DRenderer = new CSS3DRenderer();
        css3DRenderer.setSize(window.innerWidth, window.innerHeight);
        css3DRenderer.domElement.style.position = 'absolute';
        css3DRenderer.domElement.style.top = '0';
        css3DRenderer.domElement.style.left = '0';
        css3DRenderer.domElement.style.pointerEvents = 'none';
        css3DRenderer.domElement.style.zIndex = '1';
        css3DRenderer.domElement.style.background = 'transparent';
        setCssRenderer(css3DRenderer);
        
        // Add CSS3D renderer to DOM
        if (sceneRef.current) {
          sceneRef.current.appendChild(css3DRenderer.domElement);
        }

        // These values prevent a phenomenon called "z-fighting"
        // arInstance.camera.near = 10;
        // arInstance.camera.far = 100;

        setCamera(arInstance.camera)
        let addLights = false
        let isVisible = false
        sceneMap.current.forEach((scene, index) => {
          if (index === 0) {
            isVisible = true
          }

          anchors.current[scene.sceneId] = arInstance.addAnchor(scene.sceneId, isVisible)
          if (index === 0) {
            addLights = true
          }
          loadScene(scene.sceneId, addLights)
          if (index === 0) {
            anchors.current[scene.sceneId].group.visible = true
          } else {
            anchors.current[scene.sceneId].group.visible = false
          }
          ;(window as any).arInstance = arInstance
        })
        console.log('anchors', anchors.current)

        setIsReady(true)
        //await arInstance._startAR();
        setProgress(100)

        //setAnchor(anchor);
      }

      startvideo()
    }
  }, [arInstance, contentLoaded])

  useEffect(() => {
    if (!sceneRef.current) return

    //if (id === 'nPkTzHt6ecXQLRETkTd6FJ') {
    //  cameraDistance = 8;
    //}
    if (target && !arInstance) {
      if (allowUnanchored.current) {
        contentVisibleRef.current = true
      }

      setArInstance(
        new MindARThree({
          container: sceneRef.current,
          imageTargetSrc: target,
          maxTrack: 1,
          cameraDistance: null,
          isVisible: contentVisibleRef.current,
          isPreview: isPreview,
          sceneId: id,
          isEditingCamera: isEditingCamera,
        })
      )
    }
  }, [target])

  useEffect(() => {
    if (arInstance) {
      if (isEditingCamera) {
        // Stop animation and set unanchored position
        arInstance.setUnanchoredCameraPosition()
      } else {
        // Resume normal camera animation
        arInstance.repositionCamera()
      }
    }
  }, [isEditingCamera])

  useEffect(() => {
    if (arInstance && isEditingCamera) {
      arInstance.cameraDistance = cameraDistance
      arInstance.updateCameraPosition()
    }
  }, [cameraDistance])

  // const getUserCountry = async () => {
  //   return 'United States';
  //   // try {
  //   //   const position: any = await new Promise((resolve, reject) => {
  //   //     navigator.geolocation.getCurrentPosition(resolve, reject);
  //   //   });
  //   //   const { latitude, longitude } = position.coords;
  //   //   const response = await fetch(
  //   //     `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyBknQhZHMDyt-JrrR0Q8YbCT1USfwD9XOI`
  //   //   );
  //   //   const data = await response.json();
  //   //   const country = data.results[0].address_components.find(
  //   //     (component) => component.types.includes('country')
  //   //   ).long_name;
  //   //   return country;
  //   // } catch (error) {
  //   //   console.error('Error getting user country:', error);
  //   //   return null;
  //   // }
  // };

  const triggerAnalytics = async (event, linkUrl = '') => {
    let sessid: any = short.generate()
    let localId = localStorage.getItem('viewerId')
    if (localId) {
      sessid = localId
    } else {
      localStorage.setItem('viewerId', sessid)
    }
    let ip = null
    return new Promise(async (resolve, reject) => {
      
      try {
        const ipResponse = await fetch('https://api.ipify.org?format=json')
        const data = await ipResponse.json()
        ip = data.ip
      } catch (error) {
        console.log('error', error)
      }

      try {
        const payload = {
          event: event,
          userId: smarker?.uid,
          sceneId: multiAssets.current[currentAnchor.current]?.card?._id,
          markerId: smarker?._id,
          linkUrl: linkUrl,
          device: getUserAgent(),
          ip:ip,
          sessid: sessid,
        }
        
        // Send to existing Firestore analytics
        const res = await reportAnalytics(payload)
        
        // Also send to GA4 for anonymous users
        try {
          const ownerId = smarker?.uid;
          const markerId = smarker?._id;
          const experienceId = multiAssets.current[currentAnchor.current]?.card?._id;
          
          if (ownerId && markerId && experienceId) {
            // Get owner's email and business info
            const ownerInfo = await getUserInfoByUID(ownerId);
            
            // Track in GA4 based on event type
            switch (event) {
              case 'qr_scan':
                trackQRScan(
                  ownerInfo.email, 
                  ownerInfo.businessName, 
                  markerId, 
                  experienceId
                );
                break;
              case 'ar_scan':
                trackARScan(
                  ownerInfo.email, 
                  ownerInfo.businessName, 
                  markerId, 
                  experienceId
                );
                break;
              case 'click':
                if (linkUrl) {
                  trackLinkClick(
                    ownerInfo.email, 
                    ownerInfo.businessName, 
                    markerId, 
                    experienceId, 
                    linkUrl
                  );
                }
                break;
            }
          }
        } catch (ga4Error) {
          console.error('Error sending GA4 analytics:', ga4Error);
          // Don't reject the promise - GA4 tracking is supplementary
        }
        
        resolve(res)
      } catch (err) {
        console.log('error', err)
        reject(err)
      }
    })
  }

  const getUserAgent = () => {
    const userAgent = navigator.userAgent
    let deviceInfo = 'Unknown'
    if (/Android/i.test(userAgent)) {
      deviceInfo = 'Android'
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      deviceInfo = 'iOS'
    } else if (/Windows/i.test(userAgent)) {
      deviceInfo = 'Windows'
    } else if (/Mac/i.test(userAgent)) {
      deviceInfo = 'Mac'
    } else if (/Linux/i.test(userAgent)) {
      deviceInfo = 'Linux'
    }
    return deviceInfo
  }

  // const sceneOpen = async (type, userId, ) => {
  //   const userAgent = navigator.userAgent;
  //   let deviceInfo = 'Unknown';
  //   if (/Android/i.test(userAgent)) {
  //     deviceInfo = 'Android Device';
  //   } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
  //     deviceInfo = 'iOS Device';
  //   } else if (/Windows/i.test(userAgent)) {
  //     deviceInfo = 'Windows PC';
  //   } else if (/Mac/i.test(userAgent)) {
  //     deviceInfo = 'Mac';
  //   } else if (/Linux/i.test(userAgent)) {
  //     deviceInfo = 'Linux PC';
  //   }
  //   let country = 'United States';
  //   dispatch(updateAnalytics({
  //     country: {
  //       [country]: 1
  //     },
  //     device: {
  //       [deviceInfo]: 1,
  //     },
  //     os: {
  //       [navigator.platform]: 1,
  //     }
  //   }, id))
  // }

  function isPlaying(ref: any) {
    return (
      ref.currentTime >= 0 && !ref.paused && !ref.ended && ref.readyState > ref.HAVE_CURRENT_DATA
    )
  }

  useEffect(() => {
    if (targetFound && !needsTap) {
      //isScanningRef.current = false;
      setIsScanning(false)
      //console.log ('target found', targetFound)
      startMediaInCurrentAnchor()

      if (!isPreview && !isDemo.current) {
        triggerAnalytics('ar_scan')
      }
      console.log('arinstance', arInstance)
    }

    if (!targetFound && !needsTap) {
      if (allowUnanchored.current) {
        console.log('allow unanchored')
        //contentVisibleRef.current = true;
        //arInstance?.repositionCamera();
        if (arInstance) {
          
          arInstance.setVisible(true)

        }
        //isScanningRef.current = true;
      } else {
        //isScanningRef.current = true;
        contentVisibleRef.current = false
        stopAllMedia()
      }
      setIsScanning(true)
    }
  }, [targetFound])

  // Handle container resize to keep CSS3D and WebGL renderers in sync
  useEffect(() => {
    const handleResize = () => {
      if (renderer && cssRenderer && sceneRef.current) {
        // Use container dimensions instead of window dimensions for preview mode
        const container = sceneRef.current;
        const width = isPreview ? container.clientWidth : window.innerWidth;
        const height = isPreview ? container.clientHeight : window.innerHeight;
        
        // Resize both renderers
        renderer.setSize(width, height);
        cssRenderer.setSize(width, height);
        
        // Update camera aspect ratio if needed
        if (camera && camera.aspect !== undefined) {
          camera.aspect = width / height;
          camera.updateProjectionMatrix();
        }
      }
    };

    // Use ResizeObserver for container in preview mode, window resize for full mode
    if (isPreview && sceneRef.current) {
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(sceneRef.current);
      return () => resizeObserver.disconnect();
    } else {
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [renderer, cssRenderer, camera, isPreview]);

  function makeYoutube(asset: any, id = 'baseYoutube', anchorId) {
    console.log('makeYoutube', asset);
    if (!arInstance) return;
    
    const ytid = asset.asset.youtubeId;
    if (!ytid) {
      console.error('No YouTube ID provided');
      return;
    }
    
    // Get video dimensions from YouTube info, fallback to defaults
    let width = 320;
    let height = 240;
    let aspectRatio = width / height;
    
    if (asset.asset.youtubeInfo) {
      width = asset.asset.youtubeInfo.width || 320;
      height = asset.asset.youtubeInfo.height || 240;
      aspectRatio = width / height;
      console.log('Using YouTube video dimensions:', width, 'x', height, 'aspect ratio:', aspectRatio);
    }
    
    // Create shadow-casting plane for proper shadows
    const planeWidth = 1;
    const planeHeight = planeWidth / aspectRatio;
    const planeGeometry = new PlaneGeometry(planeWidth, planeHeight);
    const planeMaterial = new MeshStandardMaterial({
      transparent: true,
      opacity: 0.01,
      color: 0x000000,
      side: DoubleSide
    });
    
    const shadowPlane = new Mesh(planeGeometry, planeMaterial);
    shadowPlane.castShadow = true;
    shadowPlane.receiveShadow = true;
    
    // Apply positioning and scaling to shadow plane
    shadowPlane.position.set(
      asset.asset.coords.p[0], 
      asset.asset.coords.p[1], 
      asset.asset.coords.p[2]
    );
    shadowPlane.rotation.set(
      asset.asset.coords.r[0], 
      asset.asset.coords.r[1], 
      asset.asset.coords.r[2]
    );
    shadowPlane.scale.set(
      asset.asset.coords.s, 
      asset.asset.coords.s, 
      asset.asset.coords.s
    );
    
    shadowPlane.name = id + '_shadow';
    
    // Create CSS3D object for YouTube video
    const targetWidth = 480;
    const targetHeight = targetWidth / aspectRatio;
    
    const div = document.createElement('div');
    div.style.width = targetWidth + 'px';
    div.style.height = targetHeight + 'px';
    div.style.backgroundColor = 'transparent';
    div.style.overflow = 'hidden';
    div.style.borderRadius = '8px';
    
    const iframe = document.createElement('iframe');
    iframe.src = ['https://www.youtube.com/embed/', ytid, '?rel=0&autoplay=1&mute=1&controls=0&showinfo=0'].join('');
    iframe.style.width = targetWidth + 'px';
    iframe.style.height = targetHeight + 'px';
    iframe.style.border = '0px';
    iframe.style.borderRadius = '8px';
    iframe.allowFullscreen = true;
    div.appendChild(iframe);
    
    const cssObject = new CSS3DObject(div);
    cssObject.name = id;
    
    // CRITICAL: Apply exact same transform as shadow plane
    cssObject.position.copy(shadowPlane.position);
    cssObject.rotation.copy(shadowPlane.rotation);
    cssObject.scale.copy(shadowPlane.scale);
    
    // Adjust CSS3D object scale to match the WebGL coordinate system
    // CSS3D objects need different scaling to align with WebGL objects
    const cssScale = asset.asset.coords.s * 0.001; // Adjust this multiplier as needed
    cssObject.scale.set(cssScale, cssScale, cssScale);
    
    // Fine-tune position to align with shadow plane
    cssObject.position.z += 0.001; // Slight forward offset
    
    // Add link functionality if present
    if (asset?.asset?.linkUrl) {
      cssObject.userData['linkUrl'] = asset?.asset?.linkUrl;
    }
    
    // Clean up existing YouTube videos and shadow planes
    const existingYoutube = anchors.current[anchorId].group.getObjectByName(id);
    if (existingYoutube) {
      anchors.current[anchorId].group.remove(existingYoutube);
    }
    
    const existingShadow = anchors.current[anchorId].group.getObjectByName(id + '_shadow');
    if (existingShadow) {
      anchors.current[anchorId].group.remove(existingShadow);
    }
    
    // Add both shadow plane and CSS3D object to the scene
    anchors.current[anchorId].group.add(shadowPlane);
    anchors.current[anchorId].group.add(cssObject);
    
    // Return both objects for proper cleanup
    return {
      cssObject: cssObject,
      shadowPlane: shadowPlane
    };
  }

  // omitting code block due to eslint warning
  // function make3DLink(link, index, total, xoffset) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const spacing = 0.2;
  //       let fnButton: any = null;
  //       if ('icon' in link && link.icon && 'text' in link && link.text) {
  //         const font: any = await loadFont('/fonts/droid_sans_bold.typeface.json');
  //         const textGeometry = new TextGeometry(link.text, {
  //           font: font,
  //           size: .05,
  //           height: .01,
  //           curveSegments: 12,
  //           bevelEnabled: false,
  //           bevelThickness: 0.01,
  //           bevelSize: 0.01,
  //           bevelOffset: 0,
  //           bevelSegments: 5
  //         });

  //         const material = new MeshPhongMaterial({ color: 0xffffff });
  //         fnButton = new Mesh(textGeometry, material);
  //       } else {
  //         reject(false);
  //       }

  //       // Calculate the starting position
  //       let totalWidth = (total - 1) * spacing;
  //       let startPosition = -totalWidth / 2;

  //       fnButton.position.set(startPosition + index * spacing, xoffset, .1);
  //       anchor.group.add(fnButton);
  //       resolve(fnButton);
  //     } catch (err) {
  //       reject(false);
  //     }
  //   });
  // }

  function makeLinks(links, anchorId, size = 0.05, xoffset = -0.45, reset = false) {
    // const raycaster = new Raycaster();
    // const mouse = new Vector2();
    let btobjs: any = []
    let btlinks: any = []
    let btIds: any = []

    return new Promise(async (resolve, reject) => {
      try {
        await Promise.all(
          links.map(async (link, i) => {
            const res: any = await makeLink(link, i, links.length, size, xoffset, anchorId)
            if (res.length) {
              multiAssets.current[currentAnchor.current].currLinks[link.id] = {
                ref: res[0],
                link: res[1],
                id: res[2],
                type: link.type,
              }

              btobjs.push(res[0])
              btlinks.push(res[1])
              btIds.push(res[2])
            }
          })
        )

        setLastLinks(JSON.stringify(links))

        resolve(true)
      } catch (err) {
        resolve(false)
      }
    })
  }

  function makeLink(link, index, total, size, xoffset, anchorId) {
    const spacing = 0.6
    console.log('makeLink', link)
    return new Promise(async (resolve, reject) => {
      try {
        let glburl = '/media/glb/bigbtn-blue.glb'
        let parsed = parseLink(link)
        let svgUrl = parsed[0]
        let fnlink = parsed[1]
        console.log('link', link)
        //console.log('anchor.group', anchor.group)
        const foundExisting = anchors.current[anchorId].group.getObjectByName(link.id)
        if (foundExisting) {
          anchors.current[anchorId].group.remove(foundExisting)
        }

        let totalWidth = total * size + (total - 1) * spacing
        let startPosition = -totalWidth / 2
        let thisoffset = startPosition + index * size + index * spacing
        if (link?.yoffset) {
          thisoffset = link?.yoffset
        }
        if (link.type === 'image') {
          const btTexture: any = await loadTexture(glburl)
          btTexture.colorSpace = SRGBColorSpace
          btTexture.encoding = sRGBEncoding
          const ratio = btTexture.image.height / btTexture.image.width
          const button = new PlaneGeometry(size, size * ratio)

          const btMaterial = new MeshBasicMaterial({
            map: btTexture,
            transparent: true, // Ensure the material respects the texture's transparency
            side: DoubleSide,
          })

          let fnButton = new Mesh(button, btMaterial)
          fnButton.castShadow = true
          fnButton.userData['linkUrl'] = fnlink
          fnButton.userData['identifier'] = link.id
          fnButton.position.set(thisoffset, xoffset, 0.03)
          anchors.current[anchorId].group.add(fnButton)
          fnButton.name = link.id
          resolve([fnButton, fnlink, link.id])
        } else {
          const btmodel: any = await loadModel(glburl)

          btmodel.scene.traverse(function (child) {
            if (child.isMesh) {
              child.castShadow = true
              child.userData['linkUrl'] = fnlink
            }
          })

          //console.log('btmodel', btmodel)
          let fnButton = btmodel.scene
          fnButton.userData['identifier'] = link.id
          fnButton.scale.set(0.06, 0.06, 0.06)
          fnButton.position.set(thisoffset, xoffset, 0.03)
          fnButton.rotation.set(-0.2, 0, 0)
          console.log(link.id)
          fnButton.name = link.id

          const svgData: any = await loadSvg(svgUrl)
          console.log('svgData', svgData)
          const paths = svgData.paths

          const material = new MeshBasicMaterial({
            color: 0xffffff, // Customize color
            side: DoubleSide,
            depthWrite: false,
          })

          paths.forEach((path) => {
            const shapes = SVGLoader.createShapes(path)
            shapes.forEach((shape) => {
              const extrudeSettings = {
                depth: 1,
                bevelEnabled: true,
                bevelSegments: 2,
                steps: 2,
                bevelSize: 0.05,
                bevelThickness: 0.05,
              }

              const geometry = new ExtrudeGeometry(shape, extrudeSettings)
              const mesh = new Mesh(geometry, material)
              mesh.castShadow = true
              mesh.position.set(-4, 0.75, 1.5) // Position it slightly above the button
              mesh.scale.set(0.1, -0.1, 0.1) // Adjust size
              fnButton.add(mesh) // Add the extruded SVG to the button
            })
          })

          const font: any = await loadFont('')
          const textGeometry = new TextGeometry(link?.text || 'Click Here', {
            font: font,
            size: 1, // Adjust size
            height: 1, // Depth of the text
            curveSegments: 12,
            bevelEnabled: true,
            bevelThickness: 0.01,
            bevelSize: 0.01,
            bevelOffset: 0,
            bevelSegments: 5,
          })

          textGeometry.computeBoundingBox() // Calculate the bounds of the text
          const textWidth = textGeometry.boundingBox.max.x - textGeometry.boundingBox.min.x
          const textMesh = new Mesh(textGeometry, material)
          textMesh.castShadow = true // Optional
          textMesh.position.set(-0.6 * textWidth + 1, -0.5, 0.4) // Position it slightly above the button
          fnButton.add(textMesh)
          anchors.current[anchorId].group.add(fnButton)
          resolve([fnButton, fnlink, link.id])
        }
      } catch (err) {
        reject(false)
      }
    })
  }

  function makeDynamicButton(buttons, index, total, size, xoffset, anchorId) {
    const spacing = 0.3 // Adjust for the spacing between buttons

    return new Promise((resolve, reject) => {
      try {
        // Determine button position based on total number of buttons
        let totalWidth = total * size + (total - 1) * spacing
        let startPosition = -totalWidth / 2
        let thisoffset = startPosition + index * size + index * spacing

        // Create a rounded, 3D button shape
        const buttonShape = new Shape()
        const radius = 0.15
        const width = size
        const height = size / 3

        // Create a rounded rectangle shape
        buttonShape.moveTo(0, radius)
        buttonShape.lineTo(0, height - radius)
        buttonShape.quadraticCurveTo(0, height, radius, height)
        buttonShape.lineTo(width - radius, height)
        buttonShape.quadraticCurveTo(width, height, width, height - radius)
        buttonShape.lineTo(width, radius)
        buttonShape.quadraticCurveTo(width, 0, width - radius, 0)
        buttonShape.lineTo(radius, 0)
        buttonShape.quadraticCurveTo(0, 0, 0, radius)

        // Extrude geometry to give it depth
        const extrudeSettings = {
          depth: 0.05,
          bevelEnabled: true,
          bevelThickness: 0.02,
          bevelSize: 0.05,
          bevelSegments: 5,
        }

        const buttonGeometry = new ExtrudeGeometry(buttonShape, extrudeSettings)

        // Create a glossy material
        const buttonMaterial = new MeshPhongMaterial({
          color: buttons.color, // Dynamic color
          shininess: 100, // Glossy finish
          specular: 0xffffff, // Light reflection for gloss
        })

        // Create the button mesh
        const buttonMesh = new Mesh(buttonGeometry, buttonMaterial)
        buttonMesh.castShadow = true
        buttonMesh.position.set(thisoffset, xoffset, 0.03)
        buttonMesh.userData['linkUrl'] = buttons.link
        buttonMesh.name = buttons.id

        // Add the button mesh to the scene
        anchors.current[anchorId].group.add(buttonMesh)

        // Create dynamic text for the button
        const textAsset = {
          asset: {
            content: buttons.text, // Dynamic button text
            color: '#ffffff', // Default text color
            coords: {
              p: [thisoffset + width / 2, xoffset + height / 2, 0.08], // Text position
              s: size * 0.1, // Adjust text size
              r: [0, 0, 0], // Text rotation
            },
            extrude: 0.05, // Extrude depth for 3D text
          },
          ref: buttons.fontRef, // Font reference for the text
        }

        makeText(textAsset, buttons.id + '_text', anchorId)
        resolve(buttonMesh)
      } catch (err) {
        reject(false)
      }
    })
  }

  function makeText(asset, id, anchorId) {
    //console.log(makeDynamicButton) //hiding eslint warning

    console.log('makeText', asset)
    if (!arInstance) return // Ensure AR instance is available

    if (!asset?.asset?.content) return // Ensure text content is available
    //console.log('text', text)
    // Load the font (Make sure you have the path to a font in JSON format)
    const textGeometry = new TextGeometry(asset.asset.content, {
      font: asset.ref,
      size: asset.asset.coords.s / 10, // Adjust size
      height: asset.asset.extrude / 20, // Depth of the text
      curveSegments: 12,
      bevelEnabled: true,
      bevelThickness: 0.01,
      bevelSize: 0.01,
      bevelOffset: 0,
      bevelSegments: 5,
    })

    textGeometry.computeBoundingBox(); // Calculate the bounds of the text
    const textWidth = textGeometry.boundingBox.max.x - textGeometry.boundingBox.min.x;
    
    // Create material with reflectiveness and roughness support
    const reflectiveness = asset.asset.reflectiveness || 0;
    const roughness = asset.asset.roughness !== undefined ? asset.asset.roughness : 0.5;
    const textMaterial = new MeshStandardMaterial({ 
      color: asset.asset.color,
      metalness: reflectiveness, // 0 = non-metallic, 1 = fully metallic
      roughness: roughness // 0 = smooth/shiny, 1 = rough/matte
    });

    const textMesh = new Mesh(textGeometry, textMaterial)
    textMesh.position.set(
      asset.asset.coords.p[0] - 0.5 * textWidth,
      asset.asset.coords.p[1],
      asset.asset.coords.p[2]
    )
    textMesh.rotation.set(asset.asset.coords.r[0], asset.asset.coords.r[1], asset.asset.coords.r[2])

    textMesh.castShadow = true // Optional
    textMesh.name = id
    // const foundText = anchor.group.getObjectByName('userText');
    const foundUserLogo = anchors.current[anchorId].group.getObjectByName('userImage')

    if (foundUserLogo) {
      foundUserLogo.visible = false
    }

    const existing = anchors.current[anchorId].group.getObjectByName(id)
    if (existing) {
      // Remove particle effects first
      removeAllParticleEffects(existing, anchorId)
      anchors.current[anchorId].group.remove(existing)
    }

    anchors.current[anchorId].group.add(textMesh)
    return textMesh
  }

  function makeLogo(asset: any, id = 'baseImage', anchorId) {
    console.log('makeLogo', asset)
    if (arInstance) {
      //this ensures the image doesn't look washed out
      asset.ref.colorSpace = SRGBColorSpace
      asset.ref.encoding = sRGBEncoding

      const logoMaterial = new MeshStandardMaterial({
        map: asset.ref,
        transparent: true, // Ensure the material respects the texture's transparency
        shadowSide: DoubleSide,
        side: DoubleSide,
      })

      if (asset?.normalmap) {
        // console.log('normalmap', asset?.normalmap)
        const texture = new TextureLoader().load(asset.normalmap)
        texture.colorSpace = SRGBColorSpace
        texture.encoding = sRGBEncoding
        logoMaterial.alphaMap = texture
        logoMaterial.alphaTest = 0.05
        logoMaterial.bumpMap = texture
        logoMaterial.bumpScale = 80
        //logoMaterial.normalMap = logo.normalmap;
        //logoMaterial.normalScale = new Vector2(1, 1);
      }

      const logoratio = asset.ref.image.height / asset.ref.image.width
      //console.log('logoratio', logoratio);
      let logoGeometry = new PlaneGeometry(0.2, 0.2 * logoratio)
      if (logoratio < 1) {
        logoGeometry = new PlaneGeometry(0.2 / logoratio, 0.2)
        //scale = (scale * logoratio) * 6;
      }

      const logoPlane = new Mesh(logoGeometry, logoMaterial)

      logoPlane.scale.set(asset.asset.coords.s, asset.asset.coords.s, asset.asset.coords.s)
      logoPlane.position.set(
        asset.asset.coords.p[0],
        asset.asset.coords.p[1],
        asset.asset.coords.p[2]
      )
      logoPlane.rotation.set(
        asset.asset.coords.r[0],
        asset.asset.coords.r[1],
        asset.asset.coords.r[2]
      )

      logoPlane.name = id
      logoPlane.castShadow = true

      const foundBase = anchors.current[anchorId]?.group?.getObjectByName('baseImage')
      if (foundBase) {
        // Remove particle effects first
        removeAllParticleEffects(foundBase, anchorId)
        anchors.current[anchorId]?.group?.remove(foundBase)
      }

      const foundExisting = anchors.current[anchorId]?.group?.getObjectByName(id)
      if (foundExisting) {
        // Remove particle effects first
        removeAllParticleEffects(foundExisting, anchorId)
        anchors.current[anchorId]?.group?.remove(foundExisting)
      }
      if (asset?.asset?.linkUrl) {
        logoPlane.userData['linkUrl'] = asset?.asset?.linkUrl
      }

      anchors.current[anchorId]?.group?.add(logoPlane)
      return logoPlane
      //console.log('anchor.group', anchor.group)
      //currMeshIds.logo = logoPlane.id;
      //setMeshIds(currMeshIds);
    }
    return null
  }

  function loadStreamingVideo(asset: any) {
    return new Promise((resolve, reject) => {
      console.log('loadStreamingVideo', asset)
      let vref = document.createElement('video')
      let hls: Hls | null = null
      vref.id = asset.assetId
      const videoUrl = asset.streamUrl

      let hasResolved = false
      let manifestChecked = false

      const cleanup = (destroyHls = true) => {
        vref.removeEventListener('canplay', oncanplay)
        vref.removeEventListener('loadeddata', onLoadedData)
        vref.removeEventListener('error', onError)
        if (hls && destroyHls) {
          hls.destroy()
        }
      }

      const resolveOnce = (result) => {
        if (!hasResolved) {
          hasResolved = true
          cleanup(false) // Don't destroy HLS on successful load
          resolve(result)
        }
      }

      const oncanplay = async () => {
        console.log('Streaming video canplay - readyState:', vref.readyState)
        const canplay = await checkVideo(vref)
        resolveOnce({ref: vref, canplay: canplay, hls: hls})
      }

      const onLoadedData = async () => {
        console.log('Streaming video loadeddata - readyState:', vref.readyState)
        // HLS often doesn't fire canplay, so we'll resolve here if ready
        if (vref.readyState >= 2) {
          const canplay = await checkVideo(vref)
          resolveOnce({ref: vref, canplay: canplay, hls: hls})
        }
      }

      const onError = (e) => {
        console.error('Streaming video error:', e)
        if (!hasResolved) {
          cleanup(true) // Destroy HLS on error
          reject(new Error(`Failed to load streaming video: ${e.message}`))
        }
      }

      // HLS setup
      if (Hls.isSupported()) {
        hls = new Hls({
          enableWorker: true,
          lowLatencyMode: false,
          debug: false,
        })

        hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          console.log('HLS: Media attached')
        })

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log('HLS: Manifest parsed, video ready')
          manifestChecked = true
        })

        hls.on(Hls.Events.ERROR, (event, data) => {
          console.error('HLS error:', data)
          if (data.fatal) {
            // Check if this is a manifest loading error
            if (
              data.type === Hls.ErrorTypes.NETWORK_ERROR &&
              (data.details === Hls.ErrorDetails.MANIFEST_LOAD_ERROR ||
                data.details === Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT)
            ) {
              console.error('HLS manifest loading failed - stream may be deleted')
              onError(new Error(`HLS manifest error: ${data.details} - Stream may be unavailable`))
            } else {
              onError(new Error(`HLS fatal error: ${data.type} - ${data.details}`))
            }
          }
        })

        // Add a timeout specifically for manifest loading
        const manifestTimeout = setTimeout(() => {
          if (!manifestChecked && !hasResolved) {
            console.error('HLS manifest loading timeout')
            onError(new Error('HLS manifest loading timeout - Stream may be unavailable'))
          }
        }, 5000) // 5 second timeout for manifest loading

        hls.loadSource(videoUrl)
        hls.attachMedia(vref)
        asset.hls = hls

        // Clear the manifest timeout once we get a response
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          clearTimeout(manifestTimeout)
        })
        hls.on(Hls.Events.ERROR, () => {
          clearTimeout(manifestTimeout)
        })
      } else {
        onError(new Error('HLS not supported'))
        return
      }

      // Event listeners
      vref.addEventListener('canplay', oncanplay)
      vref.addEventListener('loadeddata', onLoadedData)
      vref.addEventListener('error', onError)

      // Video setup
      if (isPreview && isMuted) {
        vref.muted = true
      } else if (!asset.volume) {
        vref.muted = true
      } else {
        vref.muted = false
      }
      vref.loop = asset.loop
      vref.volume = asset.volume || 1
      vref.autoplay = false
      vref.playsInline = true
      vref.crossOrigin = 'anonymous'
      vref.preload = 'auto'

      // Failsafe timeout (reduced since we have manifest timeout)
      setTimeout(() => {
        if (!hasResolved) {
          console.log('Streaming video timeout - forcing completion')
          const canplay = vref.readyState >= 1
          resolveOnce({ref: vref, canplay: canplay, hls: hls})
        }
      }, 8000)
    })
  }

  function makeVideoWithCSS3D(asset: any, id = 'baseVideo', anchorId) {
    console.log('Creating CSS3D video element for HLS stream')

    const videoElement = asset.ref
    const scale = asset.asset.coords.s
    const relscale = scale * 0.6

    // Use fallback dimensions for CSS3D
    const width = 1920
    const height = 1080
    const videoAspectRatio = width / height

    const planeWidth = videoAspectRatio * relscale
    const planeHeight = relscale

    // Style the video element for CSS3D
    videoElement.style.width = `${width}px`
    videoElement.style.height = `${height}px`
    videoElement.style.backgroundColor = 'transparent'
    videoElement.style.border = 'none'
    videoElement.style.pointerEvents = 'none'

    // For now, let's create a simple placeholder mesh instead of CSS3D
    // since CSS3D requires additional setup
    console.log('Creating placeholder mesh for HLS video')

    const planeGeometry = new PlaneGeometry(planeWidth, planeHeight)
    const material = new MeshBasicMaterial({
      color: 0x666666, // Gray placeholder
      transparent: true,
      opacity: 0.8,
    })

    const mesh = new Mesh(planeGeometry, material)
    mesh.scale.set(scale, scale, scale)
    mesh.position.set(asset.asset.coords.p[0], asset.asset.coords.p[1], asset.asset.coords.p[2])
    mesh.rotation.set(asset.asset.coords.r[0], asset.asset.coords.r[1], asset.asset.coords.r[2])
    mesh.name = id
    mesh.userData = {asset: asset, isPlaceholder: true}

    // Force play the video in the background
    const forcePlay = () => {
      console.log('CSS3D: Attempting to play HLS video')
      videoElement
        .play()
        .then(() => {
          console.log('CSS3D: Video play successful')
        })
        .catch((error) => {
          console.error('CSS3D: Video play failed:', error)
        })
    }

    // Try to play immediately
    setTimeout(forcePlay, 100)

    // Clean up existing meshes
    const baseVideo = anchors.current[anchorId].group.getObjectByName('baseVideo')
    if (baseVideo) {
      anchors.current[anchorId].group.remove(baseVideo)
    }

    console.log('Placeholder mesh created for HLS video')

    // Store mesh reference
    multiAssets.current[anchorId].currAssets[id].mesh = mesh
    anchors.current[anchorId].group.add(mesh)

    return mesh
  }

  function makeStreamingVideo(asset: any, id = 'baseVideo', anchorId) {
    console.log('makeStreamingVideo', asset)

    if (!arInstance) return

    // Check if we should use CSS3D fallback (for problematic HLS streams)
    if (asset.hls && asset.ref.readyState === 0) {
      console.log('Using CSS3D fallback for HLS stream due to readyState 0')
      return makeVideoWithCSS3D(asset, id, anchorId)
    }

    // Follow the same logic as makeVideo function
    const videoElement = asset.ref
    const videoTexture = new VideoTexture(videoElement)
    videoTexture.minFilter = LinearFilter
    videoTexture.magFilter = LinearFilter
    videoTexture.format = RGBAFormat

    // Apply the same video texture settings as standard video
    videoTexture.colorSpace = SRGBColorSpace
    videoTexture.encoding = sRGBEncoding

    const ensureVideoReady = () => {
      return new Promise((resolve) => {
        if (videoElement.readyState >= 2) {
          // HAVE_CURRENT_DATA or better
          resolve(true)
        } else {
          videoElement.addEventListener(
            'canplay',
            () => {
              resolve(true)
            },
            {once: true}
          )
        }
      })
    }

    // Use the same scaling logic as standard video
    console.log('scale', asset.asset.coords.s)
    let scale = asset.asset.coords.s
    let relscale = scale * 0.6
    const width = videoElement.videoWidth || 1920 // fallback for streaming
    const height = videoElement.videoHeight || 1080 // fallback for streaming
    const videoAspectRatio = width / height
    const planeWidth = videoAspectRatio * relscale
    const planeHeight = relscale
    const planeAspectRatio = planeWidth / planeHeight

    // Create material with same logic as standard video
    let material = new MeshBasicMaterial({map: videoTexture})
    if (asset.asset.chromaKeyColor) {
      const color = new Color(asset.asset.chromaKeyColor)
      material = new ShaderMaterial({
        uniforms: {
          tex: {
            value: videoTexture,
          },
          keyColor: {value: color},
          texWidth: {value: width},
          texHeight: {value: height},
          similarity: {value: 0.01},
          smoothness: {value: 0.18},
          spill: {value: 0.1},
        },
        vertexShader: VERTEX_SHADER,
        fragmentShader: FRAGMENT_SHADER,
        transparent: true,
      })
    }
    material.shadowSide = DoubleSide

    // Apply the same texture aspect ratio logic
    let textureOffsetX = 0
    let textureOffsetY = 0
    console.log('videoAspectRatio', videoAspectRatio)
    console.log('videoAspectRatios')
    console.log(videoAspectRatio)
    console.log(planeAspectRatio)

    if (videoAspectRatio > planeAspectRatio) {
      // Video is more portrait than the plane
      const repeatX = planeAspectRatio / videoAspectRatio
      videoTexture.repeat.set(repeatX, 1)
      textureOffsetX = (1 - repeatX) / 2 // Center horizontally
    } else {
      // Video is more landscape than the plane
      const repeatY = videoAspectRatio / planeAspectRatio
      videoTexture.repeat.set(1, repeatY)
      textureOffsetY = (1 - repeatY) / 2 // Center vertically
    }

    videoTexture.offset.set(textureOffsetX, textureOffsetY)
    const vidplane = new PlaneGeometry(planeWidth, planeHeight)
    let mesh = new Mesh(vidplane, material)
    mesh.scale.set(scale, scale, scale)
    mesh.position.set(asset.asset.coords.p[0], asset.asset.coords.p[1], asset.asset.coords.p[2])
    mesh.rotation.set(asset.asset.coords.r[0], asset.asset.coords.r[1], asset.asset.coords.r[2])
    mesh.name = id
    mesh.castShadow = true

    // Clean up existing meshes (same logic as standard video)
    const baseVideo = anchors.current[anchorId].group.getObjectByName('baseVideo')
    if (baseVideo) {
      if (isPlaying(multiAssets.current[anchorId].currAssets['baseVideo'].ref)) {
        multiAssets.current[anchorId].currAssets['baseVideo'].ref.pause()
      }
      anchors.current[anchorId].group.remove(baseVideo)
      setIsMuted(true)
    }

    const existing = anchors.current[anchorId].group.getObjectByName(id)
    if (existing) {
      if (isPlaying(multiAssets.current[anchorId].currAssets[id].ref)) {
        multiAssets.current[anchorId].currAssets[id].ref.pause()
      }
      anchors.current[anchorId].group.remove(existing)
      setIsMuted(true)
    }

    // Set link URL if present
    if (asset?.asset?.linkUrl) {
      mesh.userData['linkUrl'] = asset?.asset?.linkUrl
    }

    anchors.current[anchorId].group.add(mesh)

    // Use the same animation loop as standard video
    const animate = () => {
      if (videoTexture) {
        videoTexture.needsUpdate = true
      }
      if (material && material.uniforms && material.uniforms.tex) {
        material.uniforms.tex.value.needsUpdate = true
      }
      requestAnimationFrame(animate)
    }
    animate()

    return mesh
  }

  function make3Dmodel(asset: any, id = 'baseModel', anchorId) {
    console.log('loading make3Dmodel start', asset)

    console.log('loading make3Dmodel arInstance is ready', asset)
    // let currMeshIds = { ...meshIds };
    let mixer: any
    const model = asset.ref
    const animations = asset.animations
    
    model.traverse(function (child) {
      if (child.isMesh) {
        // console.log('-------------MATERIAL', child.material)
        // child.material.depthWrite = false
        // child.material.side = 1
        if (child.material) {
          child.material.needsUpdate = true
        }

        child.castShadow = true
        if (asset?.asset?.linkUrl) {
          child.userData['linkUrl'] = asset.asset.linkUrl
        }
      }
    })
    
    // Auto-scale and center model if it appears to be using default/initial coordinates
    // This helps newly uploaded models fit in the scene properly
    const isDefaultPosition = 
      asset.asset.coords.p[0] === 0 && 
      asset.asset.coords.p[1] === 0 && 
      asset.asset.coords.p[2] === 0 &&
      asset.asset.coords.s === 1;
    
    if (isDefaultPosition) {
      // Calculate bounding box at unit scale first
      model.scale.set(1, 1, 1);
      model.position.set(0, 0, 0);
      model.updateMatrixWorld(true);
      
      const boundingBox = new Box3().setFromObject(model);
      const size = new Vector3();
      const center = new Vector3();
      boundingBox.getSize(size);
      boundingBox.getCenter(center);
      
      // Target height to match typical video plane (around 0.6 units)
      const targetHeight = 0.6;
      const maxDimension = Math.max(size.x, size.y, size.z);
      const autoScale = maxDimension > 0 ? targetHeight / maxDimension : 1;
      
      // Update asset coords with auto-calculated values
      asset.asset.coords.s = autoScale;
      
      // Calculate the position offset needed to center the model
      // We want the bounding box center to be at [0, 0, 0] in the scene
      // The offset is: (desired position) - (current bounding box center)
      const positionOffset = new Vector3(0, 0, 0).sub(center);
      
      // Update the asset coords to center the model at the origin
      asset.asset.coords.p[0] = positionOffset.x * autoScale;
      asset.asset.coords.p[1] = positionOffset.y * autoScale;
      asset.asset.coords.p[2] = positionOffset.z * autoScale;
      
      console.log(`Auto-scaled model: size=${maxDimension.toFixed(3)}, scale=${autoScale.toFixed(3)}, center offset=[${positionOffset.x.toFixed(3)}, ${positionOffset.y.toFixed(3)}, ${positionOffset.z.toFixed(3)}]`);
    }
    
    if (animations && animations.length > 0) {
      mixer = new AnimationMixer(model)
      const action = mixer.clipAction(animations[0]) // Change index as needed
      action.play()
    }

    model.scale.set(asset.asset.coords.s, asset.asset.coords.s, asset.asset.coords.s)
    model.position.set(asset.asset.coords.p[0], asset.asset.coords.p[1], asset.asset.coords.p[2])
    model.rotation.set(asset.asset.coords.r[0], asset.asset.coords.r[1], asset.asset.coords.r[2])
    model.name = id

    if (arInstance) {
      const foundBase = anchors.current[anchorId].group.getObjectByName('baseModel')
      if (foundBase) {
        // Remove particle effects first
        removeAllParticleEffects(foundBase, anchorId)
        anchors.current[anchorId].group.remove(foundBase)
      }

      const foundExisting = anchors.current[anchorId].group.getObjectByName(id)
      if (foundExisting) {
        // Remove particle effects first
        removeAllParticleEffects(foundExisting, anchorId)
        anchors.current[anchorId].group.remove(foundExisting)
      }
      console.log('adding model', model)
      anchors.current[anchorId].group.add(model)
      console.log('adding model finished', model)
      if (mixer) {
        const clock = new Clock()
        const animate = () => {
          const delta = clock.getDelta()
          mixer.update(delta)
          window.requestAnimationFrame(animate)
        }

        animate()
      }

      arInstance.renderer.render(arInstance.scene, arInstance.camera)
    }

    return model
  }

  function loadFont(url = '') {
    if (!url) {
      url = '/fonts/droid_sans_bold.typeface.json'
    }
    return new Promise((resolve, reject) => {
      const loader = new FontLoader()
      loader.load(url, resolve, undefined, reject)
    })
  }

  function loadSvg(url) {
    return new Promise((resolve, reject) => {
      const loader = new SVGLoader()
      loader.load(url, resolve, undefined, reject)
    })
  }

  function loadTexture(url) {
    return new Promise((resolve, reject) => {
      const loader = new TextureLoader()
      loader.load(url, resolve, undefined, reject)
    })
  }

  function loadModel(src) {
    const loader = new GLTFLoader()
    const dracoLoader = new DRACOLoader()
    let modelProgress = 0
    dracoLoader.setDecoderPath('https://cdn.jsdelivr.net/npm/three@0.139.2/examples/js/libs/draco/')
    loader.setDRACOLoader(dracoLoader)
    return new Promise((resolve, reject) => {
      console.log('loading model', src)
      loader.load(
        src,
        (gltf) => {
          console.log('loading model finished', gltf)
          resolve(gltf)
          dracoLoader.dispose() // Dispose after decoding
        },
        (progress) => {
          //console.log('Loading progress:', (progress.loaded / progress.total * 100) + '%');
          modelProgress = (progress.loaded / progress.total) * 100
        },
        undefined,
        (error) => {
          reject(error)
          dracoLoader.dispose()
        }
      )
    })

    // const loader = new FBXLoader()
    // return new Promise((resolve, reject) => {
    //   console.log('src: ', src)
    //   loader.load(src, (fbx) => {
    //     console.log('fbx: ', fbx)
    //     resolve(fbx);
    //   }, undefined, (error) => {
    //     reject(error);
    //   });
    // });
  }

  function loadAudio(asset: any) {
    return new Promise((resolve, reject) => {
      console.log('loadAudio.src', asset.url)
      let aref = document.createElement('audio')
      asset.assetId = id

      const cleanup = () => {
        aref.removeEventListener('canplay', oncanplay)
        aref.removeEventListener('error', onError)
      }

      const oncanplay = async () => {
        cleanup();
        const canplay = await checkAudio(aref);
        resolve({ ref: aref, canplay: canplay });
        //resolve(true);
      };

      const onError = (e) => {
        cleanup()
        reject(new Error(`Failed to load audio: ${e.message}`))
      }

      aref.addEventListener('canplay', oncanplay)
      aref.addEventListener('error', onError)
      aref.loop = asset.loop
      if (isPreview && isMuted) {
        aref.muted = true
      } else if (!asset.volume) {
        aref.muted = true
      } else {
        aref.muted = false
      }
      aref.autoplay = false
      aref.preload = 'auto'
      aref.volume = asset.volume || 1
      aref.crossOrigin = 'anonymous'
      aref.controls = false
      aref.src = asset.url
      aref.load()
      //multiAssets.current[currentAnchor.current].audioRefs.push(aref);
    })
  }

  function loadVideo(asset: any) {
    return new Promise((resolve, reject) => {
      console.log('loadVideo', asset)
      let vref = document.createElement('video')
      vref.id = asset.assetId
      console.log('loadVideo.src', asset.url)

      const PRELOAD_DURATION = 1 // Seconds of video to preload

      const cleanup = () => {
        vref.removeEventListener('canplay', oncanplay)
        vref.removeEventListener('error', onError)
      }

      const hasEnoughBuffer = () => {
        for (let i = 0; i < vref.buffered.length; i++) {
          const bufferedEnd = vref.buffered.end(i)
          const bufferedStart = vref.buffered.start(i)
          if (bufferedEnd - bufferedStart >= PRELOAD_DURATION) {
            return true
          }
        }
        return false
      }
      /*
      const onProgress = () => {
        if (hasEnoughBuffer()) {
          cleanup();
          checkVideo(vref).then(canplay => {
            resolve({ ref: vref, canplay: canplay });
          });
        }
      };
*/
      const oncanplay = async () => {
        console.log('oncanplaythrough', vref.readyState)
        if (vref.readyState >= 2) {
          cleanup()
          const canplay = await checkVideo(vref)
          resolve({ref: vref, canplay: canplay})
        }
      }

      const onError = (e) => {
        cleanup()
        reject(new Error(`Failed to load video: ${e.message}`))
      }

      //vref.addEventListener('loadeddata', onLoaded);
      vref.addEventListener('canplay', oncanplay)
      vref.addEventListener('error', onError)
      vref.src = asset.url
      if (isPreview && isMuted) {
        vref.muted = true
      } else if (!asset.volume) {
        vref.muted = true
      } else {
        vref.muted = false
      }
      vref.loop = asset.loop
      vref.muted = asset?.muted || false
      vref.volume = asset.volume || 1
      vref.autoplay = false
      vref.playsInline = true
      vref.crossOrigin = 'anonymous'
      vref.preload = 'auto'
      //video.controls = true;
      vref.load()
    })
  }

  function checkVideo(vref: any) {
    return new Promise((resolve, reject) => {
      const playPromise = vref.play()
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log('videoready', vref.readyState)
            vref.pause()

            resolve(true)
            console.log('Autoplay succeeded')
          })
          .catch((error) => {
            resolve(false)
            console.log(error)
            // Autoplay was prevented
            console.log('Autoplay was prevented. Showing fallback UI.')
            //showFallbackUI();
          })
      } else {
        resolve(false)
        // Browser does not support the play promise, show fallback UI
        //showFallbackUI();
      }
    })
  }

  function resumeVideo(vref: HTMLVideoElement) {
    // Ensure video is ready before resuming
    console.log('resuming video', vref.readyState)
    if (vref.readyState >= 2) {
      // Ready state 2 = HAVE_CURRENT_DATA
      vref.play().catch((error) => {
        console.log(`Error resuming ${vref.id}:`, error)
      })
    } else {
      console.log('reloading video', vref.readyState)
      vref.load()
      vref.addEventListener(
        'canplay',
        () => {
          console.log('Video reloaded successfully')
          if (vref.readyState >= 2) {
            // HAVE_CURRENT_DATA or better
            vref.play().catch((err) => console.error('Play failed after reload:', err))
          }
        },
        {once: true}
      )
    }
  }

  function checkAudio(aref: any) {
    return new Promise((resolve, reject) => {
      const playPromise = aref.play()
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            aref.pause()
            resolve(true)
            console.log('Autoplay succeeded')
          })
          .catch((error) => {
            resolve(false)
            console.log(error)
            // Autoplay was prevented
            console.log('Autoplay was prevented. Showing fallback UI.')
            //showFallbackUI();
          })
      } else {
        resolve(false)
        // Browser does not support the play promise, show fallback UI
        //showFallbackUI();
      }
    })
  }

  async function makeVideo(asset: any, id = 'baseVideo', anchorId) {
    if (!arInstance) return

    // let currMeshIds = { ...meshIds }; // omitting due to eslint warning
    const videoElement = asset.ref
    const videoTexture = new VideoTexture(videoElement)
    videoTexture.minFilter = LinearFilter
    videoTexture.magFilter = LinearFilter
    videoTexture.format = RGBAFormat

    // these might not apply to video since format = RGBAFormat
    videoTexture.colorSpace = SRGBColorSpace
    videoTexture.encoding = sRGBEncoding

    const ensureVideoReady = () => {
      return new Promise((resolve) => {
        if (videoElement.readyState >= 2) {
          // HAVE_CURRENT_DATA or better
          resolve(true)
        } else {
          videoElement.addEventListener(
            'canplay',
            () => {
              resolve(true)
            },
            {once: true}
          )
        }
      })
    }

    console.log('scale', asset.asset.coords.s)
    let scale = asset.asset.coords.s
    let relscale = scale * 0.6
    const width = videoElement.videoWidth
    const height = videoElement.videoHeight
    const videoAspectRatio = width / height
    const planeWidth = videoAspectRatio * relscale
    const planeHeight = relscale
    const planeAspectRatio = planeWidth / planeHeight

    await ensureVideoReady()

    let material = new MeshBasicMaterial({map: videoTexture})
    if (asset.asset.chromaKeyColor) {
      const color = new Color(asset.asset.chromaKeyColor)
      material = new ShaderMaterial({
        uniforms: {
          tex: {
            value: videoTexture,
          },
          keyColor: {value: color},
          texWidth: {value: width},
          texHeight: {value: height},
          similarity: {value: 0.01},
          smoothness: {value: 0.18},
          spill: {value: 0.1},
        },
        vertexShader: VERTEX_SHADER,
        fragmentShader: FRAGMENT_SHADER,
        transparent: true,
      })
    }
    material.shadowSide = DoubleSide

    // let vwidth = 1; // omitting due to eslint warning
    // let vheight = 1 / videoAspectRatio; // omitting due to eslint warning
    // if (videoAspectRatio <= 1) {
    //   vwidth = 1;
    //   vheight = 1 * videoAspectRatio;
    // }
    console.log('videoAspectRatio', videoAspectRatio)
    let textureOffsetX = 0
    let textureOffsetY = 0
    console.log('videoAspectRatios')
    console.log(videoAspectRatio)
    console.log(planeAspectRatio)
    // Calculate the aspect ratio
    if (videoAspectRatio > planeAspectRatio) {
      // Video is more portrait than the plane
      const repeatX = planeAspectRatio / videoAspectRatio
      videoTexture.repeat.set(repeatX, 1)
      textureOffsetX = (1 - repeatX) / 2 // Center horizontally
    } else {
      // Video is more landscape than the plane
      const repeatY = videoAspectRatio / planeAspectRatio
      videoTexture.repeat.set(1, repeatY)
      textureOffsetY = (1 - repeatY) / 2 // Center vertically
    }

    videoTexture.offset.set(textureOffsetX, textureOffsetY)
    const vidplane = new PlaneGeometry(planeWidth, planeHeight)
    let mesh = new Mesh(vidplane, material)
    mesh.scale.set(scale, scale, scale)
    mesh.position.set(asset.asset.coords.p[0], asset.asset.coords.p[1], asset.asset.coords.p[2])
    mesh.rotation.set(asset.asset.coords.r[0], asset.asset.coords.r[1], asset.asset.coords.r[2])
    mesh.name = id
    mesh.castShadow = true
    const baseVideo = anchors.current[anchorId].group.getObjectByName('baseVideo')
    if (baseVideo) {
      if (multiAssets.current[anchorId]?.currAssets?.['baseVideo']?.ref && isPlaying(multiAssets.current[anchorId].currAssets['baseVideo'].ref)) {
        multiAssets.current[anchorId].currAssets['baseVideo'].ref.pause()
      }
      anchors.current[anchorId].group.remove(baseVideo)
      setIsMuted(true)
    }

    const existing = anchors.current[anchorId].group.getObjectByName(id)
    if (existing) {
      if (multiAssets.current[anchorId]?.currAssets?.[id]?.ref && isPlaying(multiAssets.current[anchorId].currAssets[id].ref)) {
        multiAssets.current[anchorId].currAssets[id].ref.pause()
      }
      anchors.current[anchorId].group.remove(existing)
      setIsMuted(true)
    }
    //const userVideo = anchor.group.getObjectByName('userVideo');
    if (asset?.asset?.linkUrl) {
      mesh.userData['linkUrl'] = asset?.asset?.linkUrl
    }
    anchors.current[anchorId].group.add(mesh)

    const animate = () => {
      if (videoTexture) {
        videoTexture.needsUpdate = true
      }
      if (material && material.uniforms && material.uniforms.tex) {
        material.uniforms.tex.value.needsUpdate = true
      }
      requestAnimationFrame(animate)
    }
    animate()
    return mesh
    //currMeshIds.video = mesh.id;
    //setMeshIds(currMeshIds);
    //console.log('vidmeshid', vidmeshid)
    //console.log('anchor.group', anchor.group)
  }

  function addLights() {
    if (arInstance) {
      const ambientLight = new AmbientLight(0xffffff, 0.4) // Ambient light
      const directionalLight = new DirectionalLight(0xffffff, 0.6) // Directional light
      directionalLight.position.set(0, 3, 6)
      directionalLight.castShadow = true
      directionalLight.shadow.mapSize.width = 1024
      directionalLight.shadow.mapSize.height = 1024
      directionalLight.shadow.camera.near = 0.001
      directionalLight.shadow.camera.far = 100
      // Add lights to the scene
      arInstance.scene.add(ambientLight)
      arInstance.scene.add(directionalLight)
    }
  }

  async function makeButton(asset: any, id = 'baseButton', anchorId) {
    console.log('makeButton', asset)
    
    if (!arInstance) return null
    if (!asset?.asset) return null

    const buttonAsset = asset.asset
    const buttonText = buttonAsset.text || 'Click Here'
    const buttonColor = buttonAsset.buttonColor || '#667eea'
    const textColor = buttonAsset.textColor || '#FFFFFF'
    const roundness = buttonAsset.roundness || 0.15
    const thickness = buttonAsset.thickness || 0.05
    const reflectiveness = buttonAsset.reflectiveness || 0.1
    const roughness = buttonAsset.roughness || 0.5
    const linkUrl = buttonAsset.linkUrl || ''

    try {
      // Load font for text
      const font = await loadFont('/fonts/droid_sans_bold.typeface.json')
      // Remove existing button if it exists
      const existingButton = anchors.current[anchorId].group.getObjectByName(id)
      if (existingButton) {
        // Remove particle effects first
        removeAllParticleEffects(existingButton, anchorId)
        anchors.current[anchorId].group.remove(existingButton)
      }

      // Create button group to hold both button and text
      const buttonGroup = new Group()
      buttonGroup.name = id

      // First calculate text dimensions to determine button size
      let textWidth = 0
      let textHeight = 0
      
      if (font) {
        const tempTextGeometry = new TextGeometry(buttonText, {
          font: font,
          size: 0.05, // Text size
          height: thickness * 0.8, // Text depth
          curveSegments: 12,
          bevelEnabled: true,
          bevelThickness: 0.005,
          bevelSize: 0.005,
          bevelOffset: 0,
          bevelSegments: 3,
        })

        tempTextGeometry.computeBoundingBox()
        textWidth = tempTextGeometry.boundingBox ? 
          tempTextGeometry.boundingBox.max.x - tempTextGeometry.boundingBox.min.x : 0
        textHeight = tempTextGeometry.boundingBox ? 
          tempTextGeometry.boundingBox.max.y - tempTextGeometry.boundingBox.min.y : 0
        
        // Clean up temporary geometry
        tempTextGeometry.dispose()
      }

      // Calculate dynamic button dimensions with padding
      const padding = 0.08 // Horizontal padding on each side
      const verticalPadding = 0.02 // Vertical padding
      const minWidth = 0.2 // Minimum button width
      const width = Math.max(minWidth, textWidth + (padding * 2))
      const height = Math.max(0.12, textHeight + (verticalPadding * 2))
      
      // Ensure roundness doesn't exceed button dimensions
      const radius = Math.min(roundness, Math.min(width, height) / 2)

      // Create the button shape with dynamic size
      const buttonShape = new Shape()

      if (radius <= 0.015) {
        // Create sharp rectangular button for very low roundness values
        buttonShape.moveTo(0, 0)
        buttonShape.lineTo(width, 0)
        buttonShape.lineTo(width, height)
        buttonShape.lineTo(0, height)
        buttonShape.lineTo(0, 0)
      } else {
        // Create rounded rectangle shape
        buttonShape.moveTo(0, radius)
        buttonShape.lineTo(0, height - radius)
        buttonShape.quadraticCurveTo(0, height, radius, height)
        buttonShape.lineTo(width - radius, height)
        buttonShape.quadraticCurveTo(width, height, width, height - radius)
        buttonShape.lineTo(width, radius)
        buttonShape.quadraticCurveTo(width, 0, width - radius, 0)
        buttonShape.lineTo(radius, 0)
        buttonShape.quadraticCurveTo(0, 0, 0, radius)
      }

      // Extrude geometry with dynamic thickness
      const extrudeSettings = {
        depth: thickness,
        bevelEnabled: radius > 0.015, // Only enable bevel for rounded buttons
        bevelThickness: radius > 0.015 ? thickness * 0.4 : 0,
        bevelSize: radius > 0.015 ? thickness * 0.3 : 0,
        bevelSegments: radius > 0.015 ? 5 : 0,
      }

      const buttonGeometry = new ExtrudeGeometry(buttonShape, extrudeSettings)

      // Create material with metalness and roughness support
      const buttonMaterial = new MeshStandardMaterial({
        color: buttonColor,
        metalness: reflectiveness, // 0 = non-metallic, 1 = fully metallic
        roughness: roughness, // 0 = smooth/shiny, 1 = rough/matte
      })

      // Create the button mesh
      const buttonMesh = new Mesh(buttonGeometry, buttonMaterial)
      buttonMesh.castShadow = true
      buttonMesh.userData['linkUrl'] = linkUrl
      buttonMesh.userData['identifier'] = id
      buttonMesh.position.set(-width / 2, 0, 0) // Center the button

      // Add button to group
      buttonGroup.add(buttonMesh)

      // Create text for the button
      if (font) {
        const textGeometry = new TextGeometry(buttonText, {
          font: font,
          size: 0.05, // Text size
          height: thickness * 0.8, // Text depth
          curveSegments: 12,
          bevelEnabled: true,
          bevelThickness: 0.005,
          bevelSize: 0.005,
          bevelOffset: 0,
          bevelSegments: 3,
        })

        // Ensure bounding box is computed
        textGeometry.computeBoundingBox()
        
        const textMaterial = new MeshStandardMaterial({
          color: textColor,
          metalness: reflectiveness * 0.5, // Slightly less metallic than button
          roughness: roughness,
        })

        const textMesh = new Mesh(textGeometry, textMaterial)
        textMesh.castShadow = true
        textMesh.userData['linkUrl'] = linkUrl
        textMesh.userData['identifier'] = id + '_text'
        
        // Center the text on the button properly
        // Get the actual text dimensions from the geometry
        const textBox = textGeometry.boundingBox
        const actualTextWidth = textBox ? textBox.max.x - textBox.min.x : 0
        const actualTextHeight = textBox ? textBox.max.y - textBox.min.y : 0
        
        // Calculate the visual center offset from the text baseline
        const textBottomY = textBox ? textBox.min.y : 0
        const textTopY = textBox ? textBox.max.y : 0
        const textVisualCenterY = (textTopY + textBottomY) / 2
        
        textMesh.position.set(
          -actualTextWidth / 2, // Horizontal centering
          height / 2 - textVisualCenterY, // Vertical centering - move text so its visual center aligns with button center
          thickness / 2 + 0.01 // Slightly above button surface
        )

        buttonGroup.add(textMesh)
      }

      // Position the button group using asset coordinates
      if (buttonAsset.coords) {
        buttonGroup.position.set(
          buttonAsset.coords.p[0],
          buttonAsset.coords.p[1],
          buttonAsset.coords.p[2]
        )
        buttonGroup.rotation.set(
          buttonAsset.coords.r[0],
          buttonAsset.coords.r[1],
          buttonAsset.coords.r[2]
        )
        buttonGroup.scale.set(
          buttonAsset.coords.s,
          buttonAsset.coords.s,
          buttonAsset.coords.s
        )
      }

      // Add the button group to the scene
      anchors.current[anchorId].group.add(buttonGroup)
      
      console.log('Button created successfully:', id)
      return buttonGroup

    } catch (error) {
      console.error('Error creating button:', error)
      return null
    }
  }

  // Particle Effects System
  // Helper function to get the top position of an object
  function getObjectTopPosition(mesh: any): Vector3 {
    // Update world matrix to get accurate transforms
    mesh.updateMatrixWorld(true)
    
    // Calculate bounding box in world space
    const boundingBox = new Box3().setFromObject(mesh)
    const topPosition = new Vector3()
    
    // Get the top-center of the bounding box
    topPosition.x = (boundingBox.min.x + boundingBox.max.x) / 2
    topPosition.y = boundingBox.max.y // Top of the object
    topPosition.z = (boundingBox.min.z + boundingBox.max.z) / 2
    
    return topPosition
  }

  function createFireEffect(parentMesh: any, config: any) {
    const textureLoader = new TextureLoader()
    const fireParticles: any[] = []
    const fireGroup = new Group()
    fireGroup.name = 'particleEffect'
    
    // Position fire emitter at the top of the parent object
    const emitterPos = getObjectTopPosition(parentMesh)
    fireGroup.position.copy(emitterPos)
    
    // Load fire texture
    textureLoader.load(
      '/textures/fire.png',
      (texture) => {
        texture.minFilter = LinearFilter
        createFireParticles(texture)
      },
      undefined,
      (error) => {
        console.error('Failed to load fire texture:', error)
      }
    )
    
    function createFireParticles(texture: any) {
      const baseOpacity = config.opacity !== undefined ? config.opacity : 0.9
      const fireMaterial = new MeshBasicMaterial({
        map: texture,
        color: 0xff5000, // Orange tint for realistic fire color
        transparent: true,
        opacity: baseOpacity,
        depthWrite: false,
        side: DoubleSide,
        blending: AdditiveBlending,
        alphaTest: 0.1,
        toneMapped: true // Prevents tone mapping from dimming the fire
      })
      
      // Store base opacity for fading calculations
      fireGroup.userData.baseOpacity = baseOpacity
      
      const fireGeometry = new PlaneBufferGeometry(config.size || 0.7, config.size || 0.7)
      const particleCount = Math.floor(config.density || 40)
      
      for (let i = 0; i < particleCount; i++) {
        const particle = new Mesh(fireGeometry, fireMaterial.clone())
        
        // Fire particles don't cast shadows (they're emissive light sources)
        particle.castShadow = false
        particle.receiveShadow = false
        
        // Start particles at the emitter point with configurable width
        const emitterWidth = config.emitterWidth || [0.1, 0.1]
        particle.position.set(
          (Math.random() - 0.5) * emitterWidth[0], // X width
          Math.random() * 0.15, // Spread vertically upward
          (Math.random() - 0.5) * emitterWidth[1] // Z width
        )
        particle.rotation.z = Math.random() * Math.PI * 2
        particle.userData.rotationSpeed = (Math.random() - 0.5) * 0.5 // Faster rotation for fire
        particle.userData.velocity = new Vector3(
          (Math.random() - 0.5) * 0.005,
          Math.random() * 0.03 + 0.02, // Faster upward velocity for flames
          (Math.random() - 0.5) * 0.005
        )
        // Track particle age for scaling and fading
        particle.userData.age = Math.random() * 1.5 // Shorter lifetime for fire
        particle.userData.maxAge = 1.5 // Fire particles burn out quickly
        particle.userData.startScale = 0.5 // Start medium size
        particle.userData.endScale = 0.2 // Shrink as they burn out
        particle.scale.set(particle.userData.startScale, particle.userData.startScale, particle.userData.startScale)
        
        fireParticles.push(particle)
        fireGroup.add(particle)
      }
      
      fireGroup.userData.particles = fireParticles
    }
    
    fireGroup.userData.wind = config.wind || [0, 0, 0]
    fireGroup.userData.speed = config.speed !== undefined ? config.speed : 0.1
    fireGroup.userData.particles = fireParticles
    fireGroup.userData.baseOpacity = config.opacity !== undefined ? config.opacity : 0.9
    fireGroup.userData.effectType = 'fire' // Mark as fire for update logic
    fireGroup.userData.config = config // Store full config for resets
    
    return fireGroup
  }

  function createSmokeEffect(parentMesh: any, config: any) {
    const textureLoader = new TextureLoader()
    const smokeParticles: any[] = []
    const smokeGroup = new Group()
    smokeGroup.name = 'particleEffect'
    
    // Position smoke emitter at the top of the parent object
    const emitterPos = getObjectTopPosition(parentMesh)
    smokeGroup.position.copy(emitterPos)
    
    // Create canvas-based smoke texture as fallback
    const createSmokeTexture = () => {
      const canvas = document.createElement('canvas')
      canvas.width = 256
      canvas.height = 256
      const ctx = canvas.getContext('2d')!
      
      // Create radial gradient for soft smoke puff
      const gradient = ctx.createRadialGradient(128, 128, 0, 128, 128, 128)
      gradient.addColorStop(0, 'rgba(255, 255, 255, 0.8)')
      gradient.addColorStop(0.3, 'rgba(200, 200, 200, 0.5)')
      gradient.addColorStop(0.6, 'rgba(150, 150, 150, 0.2)')
      gradient.addColorStop(1, 'rgba(100, 100, 100, 0)')
      
      ctx.fillStyle = gradient
      ctx.fillRect(0, 0, 256, 256)
      
      const texture = new CanvasTexture(canvas)
      texture.minFilter = LinearFilter
      return texture
    }
    
    // Try loading custom texture, fallback to procedural
    textureLoader.load(
      '/textures/smoke.png',
      (texture) => {
        // Successfully loaded custom texture
        texture.minFilter = LinearFilter
        createSmokeParticles(texture)
      },
      undefined,
      () => {
        // Failed to load, use procedural texture
        console.log('Using procedural smoke texture')
        const proceduralTexture = createSmokeTexture()
        createSmokeParticles(proceduralTexture)
      }
    )
    
    function createSmokeParticles(texture: any) {
      const baseOpacity = config.opacity !== undefined ? config.opacity : 0.2
      const smokeMaterial = new MeshLambertMaterial({
        color: 0xdddddd,
        map: texture,
        transparent: true,
        opacity: baseOpacity,
        depthWrite: false,
        side: DoubleSide,
        alphaTest: 0
      })
      
      // Store base opacity for fading calculations
      smokeGroup.userData.baseOpacity = baseOpacity
      
      const smokeGeometry = new PlaneBufferGeometry(config.size || 0.8, config.size || 0.8)
      const particleCount = Math.floor(config.density || 50)
      
      for (let i = 0; i < particleCount; i++) {
        const particle = new Mesh(smokeGeometry, smokeMaterial.clone())
        
        // Smoke is translucent so it shouldn't cast hard shadows
        // Real smoke diffuses light rather than blocking it
        particle.castShadow = false
        particle.receiveShadow = true // Can receive shadows from other objects
        
        // Start particles at the emitter point with configurable width
        const emitterWidth = config.emitterWidth || [0.1, 0.1]
        particle.position.set(
          (Math.random() - 0.5) * emitterWidth[0], // X width
          Math.random() * 0.2, // Spread vertically upward from emitter
          (Math.random() - 0.5) * emitterWidth[1] // Z width
        )
        particle.rotation.z = Math.random() * Math.PI * 2
        particle.userData.rotationSpeed = (Math.random() - 0.5) * 0.2
        particle.userData.velocity = new Vector3(
          (Math.random() - 0.5) * 0.01,
          Math.random() * 0.02 + 0.01, // Upward velocity
          (Math.random() - 0.5) * 0.01
        )
        // Track particle age for scaling and fading
        particle.userData.age = Math.random() * 5.0 // Random starting age for varied appearance
        particle.userData.maxAge = 5.0 // Particle lifetime in seconds
        particle.userData.startScale = 0.3 // Start small
        particle.userData.endScale = 1.5 // Grow to larger size
        particle.scale.set(particle.userData.startScale, particle.userData.startScale, particle.userData.startScale)
        
        smokeParticles.push(particle)
        smokeGroup.add(particle)
      }
      
      smokeGroup.userData.particles = smokeParticles
    }
    
    smokeGroup.userData.wind = config.wind || [0, 0, 0]
    smokeGroup.userData.speed = config.speed !== undefined ? config.speed : 0.3
    smokeGroup.userData.particles = smokeParticles
    smokeGroup.userData.baseOpacity = config.opacity !== undefined ? config.opacity : 0.2
    smokeGroup.userData.effectType = 'smoke' // Mark as smoke for update logic
    smokeGroup.userData.config = config // Store full config for resets
    
    return smokeGroup
  }

  function createSparksEffect(parentMesh: any, config: any) {
    const textureLoader = new TextureLoader()
    const sparkParticles: any[] = []
    const sparkGroup = new Group()
    sparkGroup.name = 'particleEffect'
    
    // Position spark emitter at the top of the parent object
    const emitterPos = getObjectTopPosition(parentMesh)
    sparkGroup.position.copy(emitterPos)
    
    // Load sparkles texture
    textureLoader.load(
      '/textures/sparkles.png',
      (texture) => {
        texture.minFilter = LinearFilter
        createSparkParticles(texture)
      },
      undefined,
      (error) => {
        console.error('Failed to load sparkles texture:', error)
      }
    )
    
    function createSparkParticles(texture: any) {
      const baseOpacity = config.opacity !== undefined ? config.opacity : 0.6
      const sparkMaterial = new MeshBasicMaterial({
        map: texture,
        color: 0xfff500, // Yellow tint for magical sparkle glow
        transparent: true,
        opacity: baseOpacity,
        depthWrite: false,
        side: DoubleSide,
        blending: AdditiveBlending,
        alphaTest: 0.1,
        toneMapped: false // Self-illuminated sparkles
      })
      
      // Store base opacity for fading calculations
      sparkGroup.userData.baseOpacity = baseOpacity
      
      const sparkGeometry = new PlaneBufferGeometry(config.size || 0.1, config.size || 0.1)
      const particleCount = Math.floor(config.density || 70)
      
      for (let i = 0; i < particleCount; i++) {
        const particle = new Mesh(sparkGeometry, sparkMaterial.clone())
        
        // Sparkles don't cast shadows (they're tiny light sources)
        particle.castShadow = false
        particle.receiveShadow = false
        
        // Start particles at the emitter point with configurable width
        const emitterWidth = config.emitterWidth || [0.1, 0.1]
        particle.position.set(
          (Math.random() - 0.5) * emitterWidth[0], // X width
          Math.random() * 0.1, // Small vertical spread
          (Math.random() - 0.5) * emitterWidth[1] // Z width
        )
        particle.rotation.z = Math.random() * Math.PI * 2
        particle.userData.rotationSpeed = (Math.random() - 0.5) * 1.0 // Fast rotation for twinkling
        particle.userData.velocity = new Vector3(
          (Math.random() - 0.5) * 0.02,
          Math.random() * 0.03 + 0.01, // Upward with spread
          (Math.random() - 0.5) * 0.02
        )
        // Track particle age for scaling and fading
        particle.userData.age = Math.random() * 2.0
        particle.userData.maxAge = 2.0 // Medium lifetime
        particle.userData.startScale = 0.8 // Start visible
        particle.userData.endScale = 0.3 // Shrink as they fade
        particle.scale.set(particle.userData.startScale, particle.userData.startScale, particle.userData.startScale)
        
        sparkParticles.push(particle)
        sparkGroup.add(particle)
      }
      
      sparkGroup.userData.particles = sparkParticles
    }
    
    sparkGroup.userData.wind = config.wind || [0, 0, 0]
    sparkGroup.userData.speed = config.speed !== undefined ? config.speed : 0.2
    sparkGroup.userData.particles = sparkParticles
    sparkGroup.userData.baseOpacity = config.opacity !== undefined ? config.opacity : 0.6
    sparkGroup.userData.effectType = 'sparks' // Mark as sparks for update logic
    sparkGroup.userData.config = config // Store full config for resets
    
    return sparkGroup
  }

  function addParticleEffects(assetMesh: any, anchorId: string, particleEffectsData: any) {
    // Safety check FIRST - don't process if assetMesh is a Promise or invalid
    if (!assetMesh || assetMesh instanceof Promise || typeof assetMesh.then === 'function') {
      console.warn('addParticleEffects called with Promise or invalid mesh, skipping')
      return
    }
    
    if (!assetMesh.userData) {
      console.warn('assetMesh has no userData, skipping particle effects')
      return
    }
    
    // Clear all existing particle effects (now safe after checks above)
    removeAllParticleEffects(assetMesh, anchorId)
    
    if (!particleEffectsData || !particleEffectsData.effects || particleEffectsData.effects.length === 0) return
    
    const effects = particleEffectsData.effects
    const globalWind = particleEffectsData.wind || [0, 0, 0]
    
    if (!assetMesh.userData.particleEffects) {
      assetMesh.userData.particleEffects = []
    }
    
    effects.forEach((effectConfig: any) => {
      if (!effectConfig || effectConfig.type === 'none') return
      
      // Merge global wind with effect config
      const configWithWind = { ...effectConfig, wind: globalWind }
      
      let particleEffect: any = null
      
      switch (effectConfig.type) {
        case 'fire':
          particleEffect = createFireEffect(assetMesh, configWithWind)
          break
        case 'smoke':
          particleEffect = createSmokeEffect(assetMesh, configWithWind)
          break
        case 'sparks':
          particleEffect = createSparksEffect(assetMesh, configWithWind)
          break
      }
      
      if (particleEffect) {
        // Store reference to parent mesh so effects can follow it
        particleEffect.userData.parentMesh = assetMesh
        particleEffect.userData.config = configWithWind
        particleEffect.userData.effectId = effectConfig.id
        
        anchors.current[anchorId].group.add(particleEffect)
        assetMesh.userData.particleEffects.push(particleEffect)
        
        console.log(`Added ${effectConfig.type} effect to asset`)
      }
    })
  }
  
  function removeAllParticleEffects(assetMesh: any, anchorId: string) {
    // Safety check - don't process if assetMesh is a Promise or invalid
    if (!assetMesh || assetMesh instanceof Promise || typeof assetMesh.then === 'function' || !assetMesh.userData) return
    
    if (assetMesh.userData.particleEffects && Array.isArray(assetMesh.userData.particleEffects)) {
      assetMesh.userData.particleEffects.forEach((effect: any) => {
        if (effect && effect.parent && anchors.current[anchorId]?.group) {
          anchors.current[anchorId].group.remove(effect)
        }
        disposeParticleEffect(effect)
      })
      assetMesh.userData.particleEffects = []
    }
  }

  function disposeParticleEffect(effect: any) {
    if (!effect) return
    
    // Dispose of child particles if they exist
    if (effect.userData?.particles) {
      effect.userData.particles.forEach((particle: any) => {
        if (particle.geometry) particle.geometry.dispose()
        if (particle.material) particle.material.dispose()
      })
    }
    
    // Dispose of main resources
    if (effect.geometry) effect.geometry.dispose()
    if (effect.material) {
      if (Array.isArray(effect.material)) {
        effect.material.forEach((mat: any) => mat.dispose())
      } else {
        effect.material.dispose()
      }
    }
    
    // Recursively dispose children
    if (effect.children && effect.children.length > 0) {
      effect.children.forEach((child: any) => {
        if (child.geometry) child.geometry.dispose()
        if (child.material) {
          if (Array.isArray(child.material)) {
            child.material.forEach((mat: any) => mat.dispose())
          } else {
            child.material.dispose()
          }
        }
      })
    }
  }

  function updateParticleEffects(delta: number) {
    // Update all particle effects
    Object.keys(anchors.current).forEach((anchorId) => {
      if (!anchors.current[anchorId]?.group) return
      
      anchors.current[anchorId].group.traverse((child: any) => {
        // Find parent mesh if this is a particle effect
        if (child.name === 'particleEffect' && child.userData.parentMesh) {
          const parentMesh = child.userData.parentMesh
          // Keep particle effect positioned at the top of the parent mesh
          if (parentMesh.position) {
            const emitterPos = getObjectTopPosition(parentMesh)
            child.position.copy(emitterPos)
          }
        }
        
        if (child.name === 'particleEffect') {
          // Update fire particles (similar to smoke but faster and shrinking)
          if (child.userData.effectType === 'fire' && child.userData.particles) {
            const particles = child.userData.particles
            const wind = child.userData.wind || [0, 0, 0]
            const speed = child.userData.speed || 1.0
            const baseOpacity = child.userData.baseOpacity || 0.8
            
            particles.forEach((particle: any) => {
              particle.rotation.z += particle.userData.rotationSpeed * delta * speed
              
              // Update particle age
              particle.userData.age += delta * speed
              const ageRatio = particle.userData.age / particle.userData.maxAge
              
              // Scale particle (shrink over time for fire)
              const currentScale = particle.userData.startScale + 
                (particle.userData.endScale - particle.userData.startScale) * ageRatio
              particle.scale.set(currentScale, currentScale, currentScale)
              
              // Fade out with a sharper curve for fire
              if (particle.material && particle.material.opacity !== undefined) {
                const fadeRatio = 1.0 - Math.pow(ageRatio, 0.5)
                particle.material.opacity = baseOpacity * fadeRatio
              }
              
              if (particle.userData.velocity) {
                particle.position.x += (particle.userData.velocity.x + wind[0] * 0.01) * speed
                particle.position.y += (particle.userData.velocity.y + wind[1] * 0.01) * speed
                particle.position.z += (particle.userData.velocity.z + wind[2] * 0.01) * speed
                
                // Reset fire particles that are too old or too high
                if (particle.userData.age >= particle.userData.maxAge || particle.position.y > 0.5) {
                  // Use stored emitter width from parent group
                  const emitterWidth = child.userData.config?.emitterWidth || [0.1, 0.1]
                  particle.position.set(
                    (Math.random() - 0.5) * emitterWidth[0],
                    0, // Reset to emitter position
                    (Math.random() - 0.5) * emitterWidth[1]
                  )
                  particle.userData.age = 0
                  particle.scale.set(particle.userData.startScale, particle.userData.startScale, particle.userData.startScale)
                  if (particle.material) {
                    particle.material.opacity = baseOpacity
                  }
                }
              }
            })
          }
          
          // Update smoke particles
          else if (child.userData.effectType === 'smoke' && child.userData.particles) {
            const particles = child.userData.particles
            const wind = child.userData.wind || [0, 0, 0]
            const speed = child.userData.speed || 1.0
            const baseOpacity = child.userData.baseOpacity || 0.2
            
            particles.forEach((particle: any) => {
              particle.rotation.z += particle.userData.rotationSpeed * delta * speed
              
              // Update particle age
              particle.userData.age += delta * speed
              const ageRatio = particle.userData.age / particle.userData.maxAge
              
              // Scale particle (grow over time)
              const currentScale = particle.userData.startScale + 
                (particle.userData.endScale - particle.userData.startScale) * ageRatio
              particle.scale.set(currentScale, currentScale, currentScale)
              
              // Fade out particle over time (respecting base opacity)
              if (particle.material && particle.material.opacity !== undefined) {
                // Use a smoother fade curve (ease-out)
                const fadeRatio = 1.0 - Math.pow(ageRatio, 0.7)
                particle.material.opacity = baseOpacity * fadeRatio
              }
              
              if (particle.userData.velocity) {
                particle.position.x += (particle.userData.velocity.x + wind[0] * 0.01) * speed
                particle.position.y += (particle.userData.velocity.y + wind[1] * 0.01) * speed
                particle.position.z += (particle.userData.velocity.z + wind[2] * 0.01) * speed
                
                // Reset particles that are too old or too far
                if (particle.userData.age >= particle.userData.maxAge || particle.position.y > 0.8) {
                  // Use stored emitter width from parent group
                  const emitterWidth = child.userData.config?.emitterWidth || [0.1, 0.1]
                  // Reset to emitter position with random offset
                  particle.position.set(
                    (Math.random() - 0.5) * emitterWidth[0],
                    0, // Reset to emitter position
                    (Math.random() - 0.5) * emitterWidth[1]
                  )
                  // Reset age
                  particle.userData.age = 0
                  // Reset scale
                  particle.scale.set(particle.userData.startScale, particle.userData.startScale, particle.userData.startScale)
                  // Reset opacity to base opacity
                  if (particle.material) {
                    particle.material.opacity = baseOpacity
                  }
                }
              }
            })
          }
          
          // Update sparks particles
          else if (child.userData.effectType === 'sparks' && child.userData.particles) {
            const particles = child.userData.particles
            const wind = child.userData.wind || [0, 0, 0]
            const speed = child.userData.speed || 1.0
            const baseOpacity = child.userData.baseOpacity || 0.6
            
            particles.forEach((particle: any) => {
              particle.rotation.z += particle.userData.rotationSpeed * delta * speed
              
              // Update particle age
              particle.userData.age += delta * speed
              const ageRatio = particle.userData.age / particle.userData.maxAge
              
              // Scale particle (shrink over time as sparkles fade)
              const currentScale = particle.userData.startScale + 
                (particle.userData.endScale - particle.userData.startScale) * ageRatio
              particle.scale.set(currentScale, currentScale, currentScale)
              
              // Fade out with twinkling effect
              if (particle.material && particle.material.opacity !== undefined) {
                // Add slight random variation for twinkling
                const twinkle = 0.9 + Math.sin(particle.userData.age * 10) * 0.1
                const fadeRatio = 1.0 - Math.pow(ageRatio, 0.6)
                particle.material.opacity = baseOpacity * fadeRatio * twinkle
              }
              
              if (particle.userData.velocity) {
                particle.position.x += (particle.userData.velocity.x + wind[0] * 0.01) * speed
                particle.position.y += (particle.userData.velocity.y + wind[1] * 0.01) * speed
                particle.position.z += (particle.userData.velocity.z + wind[2] * 0.01) * speed
                
                // Reset sparks that are too old or too far
                if (particle.userData.age >= particle.userData.maxAge || particle.position.y > 0.4) {
                  // Use stored emitter width from parent group
                  const emitterWidth = child.userData.config?.emitterWidth || [0.1, 0.1]
                  particle.position.set(
                    (Math.random() - 0.5) * emitterWidth[0],
                    0, // Reset to emitter position
                    (Math.random() - 0.5) * emitterWidth[1]
                  )
                  particle.userData.age = 0
                  particle.scale.set(particle.userData.startScale, particle.userData.startScale, particle.userData.startScale)
                  if (particle.material) {
                    particle.material.opacity = baseOpacity
                  }
                }
              }
            })
          }
        }
      })
    })
  }

  async function loadScene(anchorId, addlights = true) {
    console.log('loadScene', arInstance)
    if (arInstance) {
      if (addlights) {
        addLights()
      }
      console.log('multiAssets.current[currentAnchor.current', multiAssets.current[anchorId])
      // let promises = [];
      Object.entries(multiAssets.current[anchorId].currAssets).forEach(([key, value]: any) => {
        console.log('assetkey', value)
        console.log('assetvalue', value)
        if (value.type === 'video') {
          // Handle video creation (makeVideo is async, makeStreamingVideo is not)
          if (value.isStreaming) {
            let mesh = makeStreamingVideo(value, key, anchorId)
            multiAssets.current[anchorId].currAssets[key]['mesh'] = mesh;
            // Add particle effects to videos if configured
            if (mesh && value.asset?.particleEffects) {
              addParticleEffects(mesh, anchorId, value.asset.particleEffects)
            }
          } else {
            // makeVideo is async, need to await it
            makeVideo(value, key, anchorId).then(mesh => {
              multiAssets.current[anchorId].currAssets[key]['mesh'] = mesh;
              // Add particle effects to videos if configured
              if (mesh && value.asset?.particleEffects) {
                addParticleEffects(mesh, anchorId, value.asset.particleEffects)
              }
            }).catch(err => {
              console.error('Error creating video:', err)
            })
          }
        } else if (value.type === 'youtube_video') {
          let youtubeObjects = makeYoutube(value, key, anchorId);
          if (youtubeObjects) {
            multiAssets.current[anchorId].currAssets[key]['mesh'] = youtubeObjects.cssObject;
            multiAssets.current[anchorId].currAssets[key]['shadowPlane'] = youtubeObjects.shadowPlane;
          }
        } else if (value.type === 'image') {
          let mesh = makeLogo(value, key, anchorId)
          multiAssets.current[anchorId].currAssets[key]['mesh'] = mesh
          // Add particle effects if configured
          if (mesh && value.asset?.particleEffects) {
            addParticleEffects(mesh, anchorId, value.asset.particleEffects)
          }
        } else if (value.type === 'text') {
          let mesh = makeText(value, key, anchorId)
          multiAssets.current[anchorId].currAssets[key]['mesh'] = mesh
          // Add particle effects if configured
          if (mesh && value.asset?.particleEffects) {
            addParticleEffects(mesh, anchorId, value.asset.particleEffects)
          }
        } else if (value.type === 'model') {
          let mesh = make3Dmodel(value, key, anchorId)
          multiAssets.current[anchorId].currAssets[key]['mesh'] = mesh
          // Add particle effects if configured
          if (mesh && value.asset?.particleEffects) {
            addParticleEffects(mesh, anchorId, value.asset.particleEffects)
          }
        } else if (value.type === 'button') {
          makeButton(value, key, anchorId).then(mesh => {
            if (mesh) {
              multiAssets.current[anchorId].currAssets[key]['mesh'] = mesh
              // Add particle effects if configured (must be in then() since makeButton is async)
              if (value.asset?.particleEffects) {
                addParticleEffects(mesh, anchorId, value.asset.particleEffects)
              }
            }
          }).catch(err => {
            console.error('Error creating button:', err)
          })
        }
      })

      if (
        isPreview &&
        currCard?.currStep === Step.UploadVideo_4 &&
        currCard?.links.length === 0 &&
        !currCard.protected?.isActive
      ) {
        makeLinks(
          [
            {link: 'youtube.com', id: 'test1', type: 'web', text: 'Visit Us'},
            {link: 'facebook.com', id: 'test2', type: 'web', text: 'Visit Us'},
          ],
          anchorId
        )
      } else {
        makeLinks(multiAssets.current[anchorId].card?.links, anchorId)
      }
    }
  }

  function parseLink(link) {
    const incl = (str) => link.link.toLowerCase().includes(str)
    const startsWith = (str) => link.link.toLowerCase().startsWith(str)

    const linkpre = '/media/buttonsvgs/'
    let linkimg = linkpre + 'web-globe.svg'
    let fnlink = link.link

    if (link.type === 'vcard') {
      linkimg = linkpre + 'vcard.svg'
    } else if (link.type === 'email') {
      linkimg = linkpre + 'email.svg'
      fnlink = `mailto:${link.link}`
    } else if (link.type === 'sms') {
      linkimg = linkpre + 'text.svg'
      fnlink = `sms:${link.link}`
    } else if (link.type === 'phone') {
      linkimg = linkpre + 'call.svg'
      fnlink = `tel:${link.link}`
    } else if (link.type === 'web') {
      if (!link.link.includes('://')) {
        fnlink = `https://${link.link}`
      }

      if (incl('youtube.com')) {
        linkimg = linkpre + 'youtube.svg'
      } else if (incl('instagram.com')) {
        linkimg = linkpre + (link?.isSocial ? 'instagram-color.svg' : 'instagram.svg')
      } else if (incl('facebook.com')) {
        linkimg = linkpre + (link?.isSocial ? 'facebook-color.svg' : 'facebook.svg')
      } else if (incl('tiktok.com')) {
        linkimg = linkpre + (link?.isSocial ? 'tiktok.svg' : 'tiktok-black.svg')
      } else if (incl('linkedin.com')) {
        linkimg = linkpre + 'linkedin.svg'
      } else if (incl('spotify.com')) {
        linkimg = linkpre + 'spotify.svg'
      } else if (incl('pinterest.com')) {
        linkimg = linkpre + 'pinterest.svg'
      } else if (incl('twitter.com') || startsWith('x.com') || startsWith('https://x.com') || startsWith('https://www.x.com')) {
        //keep at the bottom of the 'if' block
        linkimg = linkpre + 'twitter-x.svg'
      } else {
        linkimg = linkpre + 'web-globe.svg'
      }
    } else if (link.type === 'image') {
      linkimg = link.imageUrl
      fnlink = link.link
    }
    return [linkimg, fnlink]
  }

  async function loadContentMulti(cards) {
    let markerImages = []
    let socialLinks = []

    let loadcontentPromises: any[] = []
    sceneMap.current.forEach((scene, index) => {
      const card = cards[scene.sceneId]
      loadcontentPromises.push(
        loadContent(
          card,
          scene.marker,
          mindUrl.current,
          scene.sceneId,
          index + 1,
          Object.keys(cards).length
        )
      )
    })

    await Promise.all(loadcontentPromises)
  }

  function loadContent(card, marker, murl, anchorId, index = 1, totalCount = 1) {
    console.log('loading-card', card)
    console.log('loadimg-marker', marker)
    return new Promise(async (resolve, reject) => {
      try {
        if (sceneCount.current === 1) {
          const content = await fetch(murl)
          const buffer = await content.arrayBuffer()
          setTarget(buffer)
        }
        if (index === 1) {
          currentAnchor.current = anchorId
        }

        multiAssets.current[anchorId] = {
          currAssets: {},
          audioRefs: [],
          currMarker: {},
          currLinks: [],
          card: card,
        }
        //console.log('card', card);
        setSocialLinks(card?.socials || [])

        if (card?.autoForwardUrl) {
          autoForwardUrl.current = card?.autoForwardUrl
        }

        setCameraDistance(card?.cameraDistance || 3)

        if (isPreview) {
          multiAssets.current[anchorId].currMarker = {
            markerId: 'baseMarker',
            productId: '',
            name: 'Initial Marker',
            mindUrl: begMindUrl,
            imageUrl: '/media/ar/qrcode.svg',
            fullimageUrl: '/media/ar/qrcode.svg',
            aspect: 1,
            background: '#FFFFFF',
            qr: {
              visible: false,
              url: '',
              image: '/media/ar/qrcode.svg',
              color: '#000000',
              position: [0, 0],
              scale: 1,
            },
          }
          setMarkerImg('/media/ar/qrcode.svg')
        } else {
          if (isDemo.current) {
            console.log('demo marker', card?.mindUrl)
            multiAssets.current[anchorId].currMarker = {
              markerId: 'demoMarker',
              productId: '',
              name: 'Demo Marker',
              //mindUrl: card?.mindUrl,
              mindUrl: begMindUrl,
              imageUrl: card?.qrImg,
              fullimageUrl: card?.qrImg,
              aspect: 1,
              background: '#FFFFFF',
              qr: {
                visible: false,
                url: '',
                image: card?.qrImg,
                color: '#000000',
                position: [0, 0],
                scale: 1,
              },
            }
            setMarkerImg(card?.qrImg)
          } else {
            triggerAnalytics('qr_scan')
            if (index === 1) {
              multiAssets.current[anchorId].currMarker = marker
              console.log('card', card)
              setMarkerImg(marker?.compiledImageUrl)
            }
          }
        }

        if (card?.startVisible || isPreview) {
          allowUnanchored.current = true
          contentVisibleRef.current = true
        }

        let thisneedsTap = false

        let promises: any = []
        //let progress = 0;
        // Function to update progress
        //const updateProgress = () => {
        // progress++;
        //  setProgress(((progress / Object.keys(multiAssets.current).length) * 100) * (totalCount / currentCount))
        //  console.log('progress', progress);
        // };

        const addAssetWithProgress = (asset, assetId, ancid) => {
          return new Promise(async (resolve, reject) => {
            //let add = await addAsset(asset, assetId, ancid);
            //updateProgress();
            //resolve(add)
          })
        }

        if (Object.keys(card?.sceneAssets).length > 0) {
          Object.keys(card?.sceneAssets).forEach(async (assetId) => {
            loadCount.current++
            promises.push(addAsset(card?.sceneAssets[assetId], assetId, anchorId, true))
          })
        } else {
          if (isPreview) {
            let previewVideo = {
              type: 'video',
              url: begVideoUrl,
              thumbUrl: '',
              assetId: 'baseVideo',
              format: 'mp4',
              width: 0,
              height: 0,
              scaleToMarker: false,
              fillMarker: false,
              chromaKeyColor: '',
              linkUrl: '',
              loop: true,
              volume: 1,
              coords: {
                p: [0, -0.03, 0],
                r: [0, 0, 0],
                s: 1,
              },
            }
            loadCount.current++
            promises.push(addAsset(previewVideo, 'baseVideo', anchorId))

            let previewLogo = {
              type: 'image',
              url: begLogoUrl,
              assetId: 'baseImage',
              aspect: 1,
              format: 'png',
              width: 1920,
              height: 1080,
              isVector: false,
              scaleToMarker: false,
              fillMarker: false,
              linkUrl: '',
              coords: {
                p: [0, 0.4, 0.1],
                r: [0.3, 0, 0],
                s: 1,
              },
            }
            loadCount.current++
            promises.push(addAsset(previewLogo, 'baseImage', anchorId))
          }
        }
        await Promise.all(promises)

        Object.values(multiAssets.current[anchorId].currAssets).forEach((value: any) => {
          if (value.type === 'video' || value.type === 'audio') {
            if (!value.canplay) {
              thisneedsTap = true
            }
          }
        })

        if (!isPreview && !hasOrientationPermission) {
          thisneedsTap = true
        }

        if (card?.links) {
          // setCurrLinks(card.links);
        }
        console.log('multiAssets.current[anchorId]', multiAssets.current[anchorId])
        // setCurrStep(card.currStep || 0);
        if (totalCount === sceneCount.current) {
          //const currCardString = JSON.stringify(currCard);
          //lastCard.current = currCardString

          console.log('murl', murl)

          window['needsTap'] = thisneedsTap
          setNeedsTap(thisneedsTap)
          setContentLoaded(true)
        }
        sceneCount.current++
        resolve(true)
      } catch (err) {
        reject(err)
        console.log(err)
      }
    })
  }

  const handleTap = () => {
    initializeMedia()
    if (allowUnanchored.current) {
      contentVisibleRef.current = true
      //isScanningRef.current = true;
      setIsScanning(true)
    }

    stopAllMedia()

    //if (!hasAudio) {
    window['needsTap'] = false
    setNeedsTap(false)
    //}
  }

  const stopMedia = (sceneId: string) => {
    Object.values(multiAssets.current[sceneId].currAssets).forEach((asset: any) => {
      if (asset.type === 'video' || asset.type === 'audio') {
        if (isPlaying(asset.ref)) {
          asset.ref.pause()
          // Only set currentTime for non-streaming videos
          if (!asset.isStreaming && !asset.hls) {
            asset.ref.currentTime = 0
          }
        }
      }
    })
  }

  const unpauseMedia = (sceneId: string) => {
    if (!window['needsTap']) {
      Object.values(multiAssets.current[sceneId].currAssets).forEach((asset: any) => {
        if (asset.type === 'video' || asset.type === 'audio') {
          asset.ref.play()
        }
      })
    }
  }

  const startMediaInCurrentAnchor = () => {
    Object.keys(multiAssets.current).forEach((sceneId) => {
      if (currentAnchor.current === sceneId) {
        startMedia(sceneId)
      } else {
        stopMedia(sceneId)
      }
    })
  }

  const stopAllMedia = () => {
    Object.keys(multiAssets.current).forEach((sceneId) => {
      stopMedia(sceneId)
    })
  }

  const destroyAllMedia = () => {
    try {
      Object.keys(multiAssets.current).forEach((sceneId) => {
        Object.values(multiAssets.current[sceneId].currAssets).forEach((asset: any) => {
          if (asset?.ref && (asset.type === 'video' || asset.type === 'audio')) {
            try { asset.ref.pause() } catch {}
            try { asset.ref.muted = true } catch {}
            if (asset.hls) {
              try { asset.hls.destroy() } catch {}
              asset.hls = null
            }
            try {
              asset.ref.removeAttribute('src')
              asset.ref.src = ''
              asset.ref.load()
            } catch {}
          }
        })
      })
    } catch (e) {}
  }

  const disposeThreeResources = () => {
    try {
      if (scene) {
        scene.traverse((obj: any) => {
          if (obj.isMesh || obj.isLine || obj.isPoints) {
            if (obj.geometry && obj.geometry.dispose) {
              try { obj.geometry.dispose() } catch {}
            }
            const materials = Array.isArray(obj.material) ? obj.material : [obj.material]
            materials.forEach((mat) => {
              if (!mat) return
              try {
                Object.keys(mat).forEach((key) => {
                  const val = mat[key]
                  if (val && val.isTexture && val.dispose) {
                    try { val.dispose() } catch {}
                  }
                })
                if (mat.dispose) mat.dispose()
              } catch {}
            })
          }
        })
      }
    } catch (e) {}
  }

  const initializeMedia = () => {
    Object.keys(multiAssets.current).forEach((sceneId) => {
      startMedia(sceneId)
      if (currentAnchor.current !== sceneId) {
        stopMedia(sceneId)
      }
    })
  }

  const startMedia = (sceneId) => {
    let hasAudio = false
    let longestVideo: any = null
    let longestVideoTime = 0

    console.log('currentAnchor.current', currentAnchor.current)
    console.log('multiAssets.current', multiAssets.current)

    Object.values(multiAssets.current[sceneId].currAssets).forEach((asset: any) => {
      if (asset.type === 'video' || asset.type === 'audio') {
        hasAudio = true

        // Check for the asset reference
        console.log('Checking asset', asset)

        if (asset.ref && !isPlaying(asset.ref)) {
          console.log('Attempting to play asset', asset.ref)
          /*
            // Attach event listeners to monitor playback state
          asset.ref.addEventListener('play', (e) => {
            //e.stopImmediatePropagation();
             console.log(`Video ${asset.ref.src} started playing`);
          },  { once: true });
          asset.ref.addEventListener('pause', (e) => {
            //e.stopImmediatePropagation();
             console.log(`Video ${asset.ref.src} paused`);
          },  { once: true });
          asset.ref.addEventListener('ended', (e) => {
            //disable this particular stopImmediatePropagation, we've attached a 2nd event listener for longestVideo
            // e.stopImmediatePropagation();//   //
            // console.log(`Video ${asset.ref.src} ended`);
            if(asset.asset.loop) {
              asset.ref.currentTime = 0
              resumeVideo(asset.ref)
            }
          }, { once: true });
          asset.ref.addEventListener('error', (e) => {
            e.stopImmediatePropagation();
            console.error(`Video ${asset.ref.src} encountered an error:`, e);
          }, { once: true });
          */
          if (longestVideoTime < asset.ref.duration) {
            longestVideo = asset
            longestVideoTime = asset.ref.duration
          }

          // Attempt to play and catch potential errors
          resumeVideo(asset.ref)
        } else {
          console.log(`Video ${asset.ref.src} is already playing`)
        }
      }
    })

    console.log('longest video', longestVideo)
    const isMainVideoLooped = longestVideo && longestVideo?.asset?.loop
    const isNotMultiMarker = Object.keys(multiAssets.current).length < 2
    //const isNotMultiMarker = true //use this in 'main' branch

    if (isMainVideoLooped && isNotMultiMarker && !isPreview) {
      longestVideoStartTime.current = Date.now()
      longestVideo.ref.loop = false
      longestVideo.ref.addEventListener('ended', async (e) => {
        e.stopImmediatePropagation()
        window['videoLoopCount']++
        const hasPlayed45Seconds = 45000 < Date.now() - longestVideoStartTime.current

        if (hasPlayed45Seconds && 3 <= window['videoLoopCount']) {
          if (autoForwardUrl.current === '') {
            console.log('Beginning auto-forward to skanteq.com')
            await triggerAnalytics('click', 'https://www.skanteq.com/')
            window.open('https://www.skanteq.com/', '_self')
          } else {
            const url =
              autoForwardUrl.current.startsWith('http://') ||
              autoForwardUrl.current.startsWith('https://')
                ? autoForwardUrl.current
                : `https://${autoForwardUrl.current}`
            console.log('Beginning auto-forward to' + autoForwardUrl.current)
            await triggerAnalytics('click',url)
            window.open(url, '_self')
          }
        }

        // Handle looping properly for HLS vs regular videos
        if (longestVideo.isStreaming || longestVideo.hls) {
          // For HLS streams, avoid setting currentTime and use play() directly
          console.log('HLS video ended, restarting...')
          try {
            const playPromise = longestVideo.ref.play()
            if (playPromise) {
              await playPromise
            }
          } catch (error) {
            if (error instanceof Error && !error.message.includes('interrupted')) {
              console.error('HLS restart error:', error)
            }
          }
        } else {
          // For regular videos, safe to set currentTime
          console.log('Regular video ended, restarting...')
          try {
            longestVideo.ref.currentTime = 0
            const playPromise = longestVideo.ref.play()
            if (playPromise) {
              await playPromise
            }
          } catch (error) {
            if (error instanceof Error && !error.message.includes('interrupted')) {
              console.error('Regular video restart error:', error)
            }
          }
        }
      })
    } else {
      // Handle looping for non-main videos (all videos if no main video logic applies)
      Object.values(multiAssets.current[sceneId].currAssets).forEach((asset: any) => {
        if (asset.type === 'video' && asset.asset.loop && asset !== longestVideo) {
          // Remove existing handlers
          const existingHandlers = asset.ref._endedHandlers || []
          existingHandlers.forEach((handler) => {
            asset.ref.removeEventListener('ended', handler)
          })

          const loopHandler = async (e) => {
            if (asset.isStreaming || asset.hls) {
              // For HLS, just restart playback
              try {
                const playPromise = asset.ref.play()
                if (playPromise) {
                  await playPromise
                }
              } catch (error) {
                if (error instanceof Error && !error.message.includes('interrupted')) {
                  console.error('HLS loop error:', error)
                }
              }
            } else {
              // For regular videos
              try {
                asset.ref.currentTime = 0
                const playPromise = asset.ref.play()
                if (playPromise) {
                  await playPromise
                }
              } catch (error) {
                if (error instanceof Error && !error.message.includes('interrupted')) {
                  console.error('Video loop error:', error)
                }
              }
            }
          }

          asset.ref.addEventListener('ended', loopHandler)
          asset.ref._endedHandlers = [loopHandler]
        }
      })
    }

    return hasAudio
  }

  const handleViewExp = () => {
    contentVisibleRef.current = true

    //arInstance?.repositionCamera();
    //arInstance?.repositionCamera(true);
  }

  //CSS Styles

  const getContainerStyle = () => {
    let style: any = {
      width: '100%',
      height: '100%',
      position: 'relative',
      background: 'transparent',
      overflow: 'hidden',
    }

    if (isPreview) {
      style = {...style, borderRadius: '16px', boxShadow: '0px 2px 10px 4px #AAAAAA'}
    }

    return style
  }

  return (
    <>
      {!isPreview && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'fixed',
            background: 'black',
            zIndex: -100,
          }}
        ></div>
      )}
      <div style={getContainerStyle()}>
        {!isPreview && (
          <div
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              background: 'transparent',
              zIndex: 98,
            }}
          >
            <div>
              {/*
                JSON.stringify({
                  markerImg,
                  overlayVideoUrl,
                  isLoading,
                  isScanning,
                  isProcessing,
                  isPublished,
                  isDemo: isDemo.current,
                  needsTap,
                  isError,
                  contentVisible: contentVisibleRef.current,
                  allowUnanchored: allowUnanchored.current,
                  progress,
                })
              */}
            </div>
            <StatusOverlay
              markerImg={markerImg}
              videoUrl={overlayVideoUrl}
              isLoading={isLoading}
              isScanning={isScanning}
              isProcessing={isProcessing}
              isPublished={isPublished}
              isDemo={isDemo.current}
              needsTap={needsTap}
              isError={isError}
              contentVisible={contentVisibleRef.current}
              allowUnanchored={allowUnanchored.current}
              progress={progress}
              hasTapped={handleTap}
              viewExp={handleViewExp}
            />
          </div>
        )}
        {isPreview && (
          <>
            <div
              onClick={() => setIsMuted(!isMuted)}
              style={{
                position: 'absolute',
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: 'black',
                right: '30px',
                bottom: '30px',
                zIndex: 99,
              }}
            >
              <i
                style={{color: 'white', fontSize: '25px', margin: '12px'}}
                className={isMuted ? 'fas fa-volume-xmark fa-2xl' : 'fas fa-volume-high fa-2xl'}
              ></i>
            </div>
            <div
              style={{
                position: 'absolute',
                bottom: '25px',
                left: '25px',
                zIndex: 99,
                color: 'white',
                fontSize: '14px',
                fontFamily: 'sans-serif',
                fontWeight: 'normal',
              }}
            >
              Preview Window
            </div>
          </>
        )}
        {!needsTap && isReady && !isStartingAr && (
          <div
            style={{position: 'absolute', bottom: '25px', left: '25px', width: '40px', zIndex: 99}}
          >
            {socialLinks?.map((link, i) => {
              let [linkimg, fnlink] = parseLink({...link, isSocial: true})
              return (
                <a key={i} onClick={() => {
                  triggerAnalytics('click', fnlink)
                  if (!isPreview) {
                    window.open(fnlink, '_self')
                  }else{
                    window.open(fnlink, '_blank')
                  }
                }}>
                  <img
                    src={linkimg}
                    alt=''
                    style={{width: '100%', height: '40px', marginTop: '10px'}}
                  />
                </a>
              )
            })}
          </div>
        )}
        {isStartingAr && !isPreview && (
          <div
            style={{
              width: '100%',
              height: '100%',
              position: 'fixed',
              background: 'black',
              zIndex: 98,
            }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                textAlign: 'center',
                fontSize: '20px',
                marginTop: '20px',
                fontWeight: 'bold',
                color: 'white',
              }}
            >
              {/* {isGettingCamera ? 'Allow Camera Access to Continue' : 'Loading AR Scene...'} */}
              <div
                style={{
                  width: '200px',
                  height: '200px',
                  position: 'relative',
                  left: '50%',
                  marginTop: '20px',
                  transform: 'translate(-50%, 0%)',
                }}
              >
                <img
                  style={{width: '200px', height: '200px'}}
                  src='/media/ar/arloading.gif'
                  alt=''
                />
                <img
                  style={{
                    width: '80px',
                    height: '80px',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                  src={isGettingCamera ? '/media/ar/camera-100.png' : '/media/ar/logo.png'}
                  alt=''
                />
              </div>
              <img className='skanteq-logo' src='/media/splash/skanteq_logo.png' alt='' />
            </div>
          </div>
        )}
        <div style={{width: '100%', height: '100%', zIndex: 97}} ref={sceneRef}>
          {/*userdata?.protected?.isAdmin && <AssetFileList/>*/}
        </div>
      </div>
    </>
  )
}

export default ARScene
